var _metadata, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEina03Regular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20190801 at Fri Mar 25 12:36:10 2016\n By www-data\nCopyright (c) 2013 Textaxis. v 1.0 by In~igo Jerez. Barcelona. All rights reserved.\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Eina03Regular",
    horizAdvX: 582
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Eina03Regular",
    fontWeight: 400,
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 0 0 0 0 0 0 0 0 0",
    ascent: 774,
    descent: -226,
    xHeight: 509,
    capHeight: 710,
    bbox: "-62 -252 1216 1104",
    underlineThickness: 50,
    underlinePosition: -100,
    unicodeRange: "U+0020-FB02"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 260
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fi",
    unicode: "fi",
    horizAdvX: 576,
    d: "M111 509v84q0 78 41 117.5t110 39.5l34 -2v-65q-10 2 -28 2q-43 0 -64.5 -21t-21.5 -68v-87h115v-60h-115v-449h-71v449h-99v60h99zM438 635q-23 0 -37 13.5t-14 35.5t14.5 36.5t36.5 14.5t36.5 -14.5t14.5 -36.5t-14.5 -35.5t-36.5 -13.5zM402 0v509h71v-509h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl",
    unicode: "fl",
    horizAdvX: 561,
    d: "M111 509v84q0 78 41 117.5t110 39.5l34 -2v-65q-10 2 -28 2q-43 0 -64.5 -21t-21.5 -68v-87h115v-60h-115v-449h-71v449h-99v60h99zM473 0h-71v750h71v-750z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 260
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 333
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 260
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 247,
    d: "M94 164l-12 546h83l-12 -546h-59zM124 -8q-23 0 -38.5 15t-15.5 37q0 23 15.5 38t38.5 15t38 -15t15 -38q0 -22 -15 -37t-38 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 403,
    d: "M151 710v-296h-70v296h70zM321 710v-296h-69v296h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 616,
    d: "M573 494l-12 -59h-109l-33 -162h108l-12 -59h-109l-45 -214h-61l44 214h-132l-44 -214h-62l45 214h-108l12 59h109l34 162h-110l13 59h110l45 216h62l-46 -216h132l46 216h61l-46 -216h108zM259 435l-34 -162h132l34 162h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    d: "M328 -124h-50v110q-116 4 -173.5 64t-65.5 151h73q17 -141 166 -148v278l-23 7q-96 29 -141.5 77.5t-45.5 119.5q0 76 55 129.5t155 59.5v110h50v-110q101 -7 154 -66t59 -149h-73q-6 60 -42 99.5t-98 47.5v-264l14 -3q107 -23 154 -74t47 -130q0 -80 -56 -134.5 t-159 -63.5v-111zM141 537q0 -51 29.5 -79.5t107.5 -51.5v251q-68 -4 -102.5 -36t-34.5 -84zM469 181q0 51 -31 82t-110 54v-263q66 7 103.5 40.5t37.5 86.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 940,
    d: "M243 0l392 710h62l-392 -710h-62zM138 490q0 -168 93 -168q92 0 92 168q0 169 -92 169q-93 0 -93 -169zM76 490q0 107 39.5 166.5t115.5 59.5q75 0 114.5 -59.5t39.5 -166.5t-39.5 -166t-114.5 -59q-76 0 -115.5 59t-39.5 166zM617 219q0 -168 93 -168q92 0 92 168 q0 169 -92 169q-93 0 -93 -169zM555 219q0 107 39.5 166.5t115.5 59.5q75 0 114.5 -59.5t39.5 -166.5t-39.5 -166t-114.5 -59q-76 0 -115.5 59t-39.5 166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 673,
    d: "M118 548q0 74 51.5 125.5t136.5 51.5t137 -48.5t52 -118.5q0 -67 -42.5 -114.5t-138.5 -82.5l188 -191q45 69 45 163l-5 65h70q4 -29 4 -63q0 -123 -66 -215l118 -120h-94l-69 70q-92 -85 -225 -85q-110 0 -172 54.5t-62 140.5q0 135 156 201q-84 87 -84 167zM281 50 q104 0 177 68l-210 215q-66 -28 -98 -62.5t-32 -88.5q0 -61 43.5 -96.5t119.5 -35.5zM189 550q0 -62 71 -134l7 -8l30 13q71 31 99 60t28 77t-34 76.5t-84 28.5q-52 0 -84.5 -30.5t-32.5 -82.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 232,
    d: "M151 710v-296h-70v296h70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 315,
    d: "M163 292q0 -255 116 -458h-72q-117 187 -117 458t117 458h72q-116 -204 -116 -458z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 315,
    d: "M152 292q0 252 -117 458h72q118 -189 118 -458t-118 -458h-72q117 205 117 458z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 389,
    d: "M361 583l-123 -39l76 -104l-45 -33l-75 105l-75 -105l-45 34l76 104l-123 39l18 53l122 -41l-1 129h56l-1 -130l123 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    d: "M257 509h69v-221h223v-68h-223v-220h-69v220h-224v68h224v221z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 216,
    d: "M79 94h84l-73 -203h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 396,
    d: "M352 288v-67h-308v67h308z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 216,
    d: "M108 -8q-24 0 -39.5 15t-15.5 39q0 23 15.5 38.5t39.5 15.5q23 0 39 -15.5t16 -38.5q0 -24 -15.5 -39t-39.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 408,
    d: "M22 0l289 710h75l-289 -710h-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    d: "M291 -15q-118 0 -183 99t-65 271t65 271t183 99t183 -99t65 -271t-65 -271t-183 -99zM291 657q-81 0 -127 -77t-46 -225t46 -225t127 -77t127 77t46 225t-46 225t-127 77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    d: "M513 64v-64h-408v64h168v575h-160v50l176 21h57v-646h167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    d: "M526 0h-471v62l284 261q95 87 95 180q0 71 -40 113t-112 42q-76 0 -113.5 -45t-37.5 -120l2 -20h-74q-2 11 -2 22q0 104 60 167t165 63q109 0 168 -60.5t59 -158.5q0 -68 -30.5 -124t-97.5 -115l-223 -198h368v-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    d: "M219 331v65h60q80 0 122.5 36t42.5 91q0 63 -39.5 99t-115.5 36q-69 0 -106 -38.5t-42 -94.5h-73q6 85 66.5 142.5t155.5 57.5q106 0 166.5 -55t60.5 -144q0 -54 -29.5 -97t-87.5 -63q65 -19 96.5 -63t31.5 -104q0 -95 -63 -154.5t-173 -59.5q-107 0 -168.5 59t-70.5 157 h74q7 -66 49 -108t116 -42t117.5 38t43.5 110q0 65 -45 98.5t-124 33.5h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    d: "M545 240v-66h-92v-174h-71v174h-356v64l349 472h78v-470h92zM382 608h-1l-272 -368h273v368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    d: "M73 303l57 407h366v-69h-309l-32 -236q58 58 148 58q104 0 165 -67t61 -165q0 -104 -66.5 -175t-170.5 -71q-102 0 -165 56.5t-73 149.5h75q9 -59 49.5 -99t113.5 -40q72 0 117.5 49.5t45.5 129.5q0 75 -44 121t-120 46q-58 0 -98.5 -30.5t-53.5 -64.5h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    d: "M297 -15q-110 0 -176 71t-66 178q0 236 268 476h97q-186 -151 -255 -304q57 55 143 55q104 0 168 -69t64 -168t-68.5 -169t-174.5 -70zM464 224q0 77 -47 125.5t-120 48.5q-74 0 -120.5 -48t-46.5 -126t46.5 -125.5t120.5 -47.5q73 0 120 48t47 125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    d: "M103 547h-71v163h512v-65q-115 -146 -179 -295t-95 -350h-78q62 378 262 641h-351v-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    d: "M291 -15q-115 0 -177 57.5t-62 147.5q0 57 31 105.5t87 71.5q-48 23 -73 68t-25 97q0 82 58 137.5t161 55.5t161.5 -55.5t58.5 -138.5q0 -51 -26 -96t-74 -68q56 -23 87 -71.5t31 -105.5q0 -91 -61.5 -148t-176.5 -57zM291 332q-75 0 -119.5 -37.5t-44.5 -101.5 t42 -103.5t122 -39.5t122 39.5t42 103.5t-44.5 101.5t-119.5 37.5zM291 397q70 0 109.5 37t39.5 96q0 57 -38.5 93.5t-110.5 36.5t-110.5 -36t-38.5 -93q0 -60 39 -97t110 -37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    d: "M286 725q110 0 176 -71.5t66 -177.5q0 -237 -269 -476h-96q181 146 254 303q-60 -55 -143 -55q-103 0 -167 69.5t-64 168.5t68.5 169t174.5 70zM119 486q0 -78 46.5 -126.5t120.5 -48.5q73 0 120 48.5t47 126.5q0 77 -47 125t-120 48q-74 0 -120.5 -48t-46.5 -125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 216,
    d: "M108 -8q-24 0 -39.5 15t-15.5 39q0 23 15.5 38.5t39.5 15.5q23 0 39 -15.5t16 -38.5q0 -24 -15.5 -39t-39.5 -15zM108 408q-24 0 -39.5 15.5t-15.5 38.5q0 24 15.5 39.5t39.5 15.5q23 0 39 -15.5t16 -39.5q0 -23 -16 -38.5t-39 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 217,
    d: "M108 408q-24 0 -39.5 15.5t-15.5 38.5q0 24 15.5 39.5t39.5 15.5q23 0 39 -15.5t16 -39.5q0 -23 -16 -38.5t-39 -15.5zM79 94h84l-73 -203h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    d: "M528 101v-74l-474 194v61l474 194v-73l-385 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    d: "M549 187v-69h-516v69h516zM549 390v-69h-516v69h516z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    d: "M54 27v74l385 151l-385 151v73l474 -194v-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 522,
    d: "M38 514q0 90 59.5 150.5t158.5 60.5q103 0 160 -55.5t57 -142.5q0 -49 -20 -90t-48 -69t-56 -52.5t-48 -52.5t-20 -58l4 -41h-70q-5 24 -5 42q0 41 19.5 75.5t47 59.5t55.5 50.5t47.5 59t19.5 72.5q0 64 -38.5 100t-104.5 36q-65 0 -104.5 -41t-39.5 -108l3 -39h-74 q-3 20 -3 43zM254 -8q-24 0 -39 14.5t-15 37.5t15 38t39 15q23 0 38 -15t15 -38q0 -22 -15 -37t-38 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 825,
    d: "M502 278q0 49 -21 78t-64 29q-55 0 -87 -43.5t-32 -114.5q0 -108 93 -108q50 0 80.5 48t30.5 111zM653 28h67q-48 -70 -128 -110t-174 -40q-171 0 -269 102t-98 267q0 161 104.5 270.5t273.5 109.5q157 0 251 -87t94 -226q0 -111 -58 -179.5t-134 -68.5q-69 0 -85 62 q-40 -62 -118 -62q-66 0 -105 43t-39 117q0 88 47 150.5t127 62.5q85 0 115 -66l11 52h58l-44 -221q-3 -14 -3 -27q0 -26 12.5 -41t34.5 -15q57 0 90.5 54.5t33.5 133.5q0 124 -79 194.5t-210 70.5q-145 0 -230.5 -93t-85.5 -233q0 -148 82.5 -232.5t224.5 -84.5 q76 0 137.5 28t96.5 69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 672,
    d: "M82 0h-78l292 710h79l293 -710h-81l-67 166h-370zM336 621h-2l-158 -387h317z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 674,
    d: "M371 0h-270v710h263q117 0 175 -51t58 -138q0 -57 -29.5 -100t-81.5 -61q59 -17 93 -61t34 -105q0 -94 -63 -144t-179 -50zM374 326h-200v-258h199q167 0 167 129q0 64 -44 96.5t-122 32.5zM367 642h-193v-248h193q157 0 157 124t-157 124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 781,
    d: "M52 355q0 161 96.5 265.5t254.5 104.5q130 0 220 -72t115 -193h-77q-21 90 -91 143t-167 53q-124 0 -199.5 -83t-75.5 -218t75.5 -218t199.5 -83q97 0 167 53t91 143h77q-25 -121 -115 -193t-220 -72q-158 0 -254.5 104.5t-96.5 265.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 763,
    d: "M316 0h-215v710h215q186 0 290.5 -96t104.5 -259t-104.5 -259t-290.5 -96zM635 355q0 135 -82.5 210t-240.5 75h-138v-570h138q158 0 240.5 75t82.5 210z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 636,
    d: "M578 69v-69h-477v710h477v-69h-404v-246h383v-69h-383v-257h404z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 583,
    d: "M174 0h-73v710h452v-69h-379v-246h358v-69h-358v-326z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 818,
    d: "M450 311v68h315q1 -15 1 -24q0 -158 -98.5 -264t-258.5 -106t-258.5 106t-98.5 264t98.5 264t258.5 106q129 0 218 -67.5t122 -183.5h-79q-30 86 -99 134t-162 48q-124 0 -202.5 -83.5t-78.5 -217.5t78.5 -217.5t202.5 -83.5q113 0 189 70.5t89 186.5h-237z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 764,
    d: "M662 710v-710h-73v326h-415v-326h-73v710h73v-315h415v315h73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 276,
    d: "M174 710v-710h-73v710h73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 593,
    d: "M429 221v489h73v-487q0 -108 -61 -172t-167 -64q-105 0 -166 61t-61 165l2 44h74q-2 -17 -2 -44q0 -71 40 -115.5t113 -44.5q74 0 114.5 44t40.5 124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 703,
    d: "M700 0h-93l-278 362l-155 -152v-210h-73v710h73v-409l408 409h98l-300 -296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 541,
    d: "M530 69v-69h-429v710h73v-641h356z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 849,
    d: "M167 710l257 -331l258 331h66v-710h-73v586l-249 -316h-4l-248 316v-586h-73v710h66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 766,
    d: "M174 593v-593h-73v710h77l414 -594v594h73v-710h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 828,
    d: "M128 355q0 -133 81 -217t205 -84t205 84t81 217t-81 217t-205 84t-205 -84t-81 -217zM776 355q0 -158 -100.5 -264t-261.5 -106t-261.5 106t-100.5 264t100.5 264t261.5 106t261.5 -106t100.5 -264z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 644,
    d: "M174 369h206q75 0 112.5 35.5t37.5 100.5q0 64 -37.5 99.5t-112.5 35.5h-206v-271zM174 299v-299h-73v710h276q117 0 173 -56.5t56 -148.5t-56.5 -149t-172.5 -57h-203z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 828,
    d: "M776 355q0 -91 -35 -167.5t-100 -126.5l137 -191h-86l-109 153q-78 -38 -169 -38q-161 0 -261.5 106t-100.5 264t100.5 264t261.5 106t261.5 -106t100.5 -264zM700 355q0 133 -80.5 217t-205.5 84q-124 0 -205 -84t-81 -217t81 -217t205 -84t205 84t81 217z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 672,
    d: "M637 0h-88l-167 309h-208v-309h-73v710h292q115 0 171.5 -55.5t56.5 -144.5q0 -75 -40.5 -127t-122.5 -67zM545 510q0 60 -37.5 95t-111.5 35h-222v-261h222q74 0 111.5 34.5t37.5 96.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 633,
    d: "M307 52q89 0 139.5 34.5t50.5 98.5q0 45 -23 74t-60.5 42t-82 22t-89.5 20t-82.5 29t-60.5 56.5t-23 96.5q0 82 65 141t178 59q115 0 179 -64t66 -166h-71q-2 74 -48.5 119t-124.5 45q-80 0 -125.5 -35.5t-45.5 -95.5q0 -42 23.5 -68.5t60.5 -39.5t82 -21.5t90 -21 t82 -31.5t60.5 -58.5t23.5 -97.5q0 -92 -73.5 -148t-192.5 -56q-129 0 -195 64.5t-70 164.5h72q6 -79 58 -121t137 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 545,
    d: "M536 710v-70h-227v-640h-73v640h-227v70h527z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 736,
    d: "M368 -15q-129 0 -205.5 79t-76.5 229v417h73v-424q0 -108 54.5 -171t154.5 -63t154.5 63t54.5 171v424h73v-417q0 -150 -77 -229t-205 -79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 669,
    d: "M579 710h80l-286 -710h-78l-285 710h82l243 -617h2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 1033,
    d: "M516 613l-191 -613h-80l-228 710h82l185 -613h2l190 613h83l190 -614h2l186 614h79l-228 -711h-81l-189 614h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 675,
    d: "M337 417l230 293h91l-277 -350l288 -360h-95l-237 303l-238 -303h-93l287 360l-279 350h94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 615,
    d: "M530 710h85l-271 -458v-252h-73v252l-271 458h82l225 -381h2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 642,
    d: "M594 710v-63l-455 -578h459v-69h-554v63l456 578h-452v69h546z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 301,
    d: "M279 -100v-66h-204v916h204v-66h-135v-784h135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 408,
    d: "M97 710l289 -710h-75l-289 710h75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 301,
    d: "M22 -166v66h135v784h-135v66h204v-916h-204z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    d: "M515 241h-73l-151 378l-151 -378h-73l193 469h61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 500,
    d: "M500 -96v-67h-500v67h500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 349,
    d: "M103 759h78l66 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 638,
    d: "M550 509v-509h-68v94q-57 -106 -193 -106q-112 0 -176 77.5t-64 188.5t64 189t176 78q136 0 193 -106v94h68zM121 254q0 -86 49.5 -144t132.5 -58t131 58t48 144q0 87 -48 145t-131 58t-132.5 -58.5t-49.5 -144.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 638,
    d: "M158 417q58 104 190 104q113 0 177 -77.5t64 -189.5q0 -111 -64 -188.5t-177 -77.5q-134 0 -193 106v-94h-68v750h71v-333zM156 254q0 -86 48 -144t131 -58t132.5 58t49.5 144q0 87 -49.5 145t-132.5 58t-131 -57.5t-48 -145.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 577,
    d: "M49 254q0 109 69.5 188t181.5 79q98 0 160 -55.5t78 -137.5h-72q-16 60 -59 94.5t-107 34.5q-80 0 -129.5 -57t-49.5 -146q0 -88 49.5 -145t129.5 -57q64 0 107 34.5t59 94.5h72q-16 -82 -78 -137.5t-160 -55.5q-112 0 -181.5 78.5t-69.5 187.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 638,
    d: "M479 417v333h71v-750h-68v94q-57 -106 -193 -106q-112 0 -176 77.5t-64 188.5q0 112 64 189.5t176 77.5q132 0 190 -104zM482 254q0 88 -48 145.5t-131 57.5t-132.5 -58t-49.5 -145q0 -86 49.5 -144t132.5 -58t131 58t48 144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 593,
    d: "M543 234h-423q5 -80 54 -131t127 -51q57 0 100 29.5t60 77.5h74q-23 -76 -85 -123.5t-150 -47.5q-116 0 -183.5 77.5t-67.5 189.5q0 110 69.5 188t180.5 78t178 -74.5t67 -185.5zM299 457q-72 0 -120 -46.5t-57 -118.5h351q-7 75 -53.5 120t-120.5 45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 311,
    d: "M110 509v84q0 78 41 117.5t110 39.5l34 -2v-65q-10 2 -28 2q-43 0 -64.5 -21t-21.5 -68v-87h115v-60h-115v-449h-71v449h-99v60h99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 632,
    d: "M481 416v93h68v-484q0 -108 -61.5 -176t-176.5 -68q-100 0 -158.5 48t-73.5 114h73q15 -45 57.5 -71.5t103.5 -26.5q77 0 121 45.5t44 118.5v95q-59 -103 -189 -103q-110 0 -175 76t-65 184t65 184t175 76q133 0 192 -105zM481 261q0 85 -48.5 140.5t-130.5 55.5 t-131.5 -56t-49.5 -140t49.5 -140.5t131.5 -56.5t130.5 56t48.5 141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 598,
    d: "M158 750v-312q18 31 60 57t105 26q92 0 142.5 -54t50.5 -142v-325h-71v311q0 71 -33.5 109.5t-100.5 38.5t-110 -41.5t-43 -116.5v-301h-71v750h71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 246,
    d: "M123 635q-23 0 -37 13.5t-14 35.5t14 36.5t37 14.5q22 0 36.5 -14.5t14.5 -36.5t-14.5 -35.5t-36.5 -13.5zM87 0v509h71v-509h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 246,
    d: "M123 635q-23 0 -37 13.5t-14 35.5t14 36.5t37 14.5q22 0 36.5 -14.5t14.5 -36.5t-14.5 -35.5t-36.5 -13.5zM87 -208v717h71v-717h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 553,
    d: "M439 509h95l-211 -210l227 -299h-88l-189 251l-115 -112v-139h-71v750h71v-524z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 246,
    d: "M158 0h-71v750h71v-750z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 930,
    d: "M503 297v-297h-71v311q0 69 -31.5 108.5t-96.5 39.5q-64 0 -105 -42t-41 -114v-303h-71v509h68v-78q49 90 161 90q121 0 166 -98q24 41 70 69.5t109 28.5q89 0 137.5 -55.5t48.5 -140.5v-325h-71v311q0 68 -31.5 108t-95.5 40q-63 0 -104.5 -42t-41.5 -120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 598,
    d: "M155 509v-78q18 34 60 62t108 28q92 0 142.5 -54t50.5 -142v-325h-71v311q0 71 -33.5 109.5t-100.5 38.5t-110 -41t-43 -115v-303h-71v509h68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 617,
    d: "M308 -12q-116 0 -187.5 78.5t-71.5 187.5q0 110 71.5 188.5t187.5 78.5q117 0 188.5 -78.5t71.5 -188.5q0 -109 -71.5 -187.5t-188.5 -78.5zM121 254q0 -87 52 -144.5t135 -57.5q84 0 136 57.5t52 144.5q0 88 -52 145.5t-136 57.5t-135.5 -57.5t-51.5 -145.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 638,
    d: "M158 92v-300h-71v717h68v-94q60 106 193 106q113 0 177 -77.5t64 -189.5q0 -111 -64 -188.5t-177 -77.5q-133 0 -190 104zM156 254q0 -86 48 -144t131 -58t132.5 58t49.5 144q0 87 -49.5 145t-132.5 58t-131 -57.5t-48 -145.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 638,
    d: "M479 92q-57 -104 -190 -104q-112 0 -176 77.5t-64 188.5q0 112 64 189.5t176 77.5q135 0 193 -106v94h68v-717h-71v300zM482 254q0 88 -48 145.5t-131 57.5t-132.5 -58t-49.5 -145t49.5 -145t132.5 -58t131 58t48 145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 351,
    d: "M335 513v-67q-12 1 -25 1q-68 0 -110 -40.5t-42 -117.5v-289h-71v509h68v-79q18 33 59 58.5t104 25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 504,
    d: "M250 -12q-103 0 -153.5 48.5t-55.5 122.5h72q4 -51 38.5 -80t98.5 -29q63 0 98.5 23.5t35.5 62.5q0 40 -32.5 59.5t-78.5 26.5t-92.5 17t-79 42t-32.5 90q0 62 51 106t138 44q96 0 142 -49t52 -112h-71q-5 44 -36 71.5t-89 27.5q-57 0 -87.5 -24t-30.5 -61 q0 -33 23.5 -52t58.5 -24.5t75.5 -14.5t75.5 -20t58.5 -43t23.5 -82q0 -62 -52.5 -106t-150.5 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 291,
    d: "M179 449v-449h-71v449h-97v60h97v145h71v-145h104v-60h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 586,
    d: "M293 -12q-103 0 -157 57.5t-54 147.5v316h71v-311q0 -70 36 -109t104 -39t104 39t36 109v311h71v-316q0 -90 -54 -147.5t-157 -57.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 532,
    d: "M266 82l176 427h74l-215 -509h-72l-213 509h77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 827,
    d: "M551 0l-137 419h-1l-139 -419h-74l-176 509h76l137 -425l140 425h74l138 -425l139 425h75l-178 -509h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 540,
    d: "M513 509l-202 -251l209 -258h-89l-162 204l-162 -204h-87l207 257l-202 252h88l157 -197l156 197h87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 532,
    d: "M142 -208l87 208l-213 509h77l173 -427l175 427h75l-302 -717h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 526,
    d: "M472 452l-330 -389h334v-63h-426v57l330 389h-326v63h418v-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 314,
    d: "M243 -166q-65 0 -97 36t-32 101v235q0 54 -51 54h-23v64h23q51 0 51 54v235q0 65 32 101t97 36l49 -4v-66q-20 4 -45 4q-35 0 -49.5 -17t-14.5 -51v-233q0 -68 -40 -91q40 -25 40 -92v-232q0 -34 14.5 -51t49.5 -17l45 4v-66q-18 -4 -49 -4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 274,
    d: "M172 0h-70v750h70v-750z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 314,
    d: "M71 -166l-49 4v66q20 -4 44 -4q35 0 50 17t15 51v232q0 68 40 92q-40 23 -40 91v233q0 34 -15 51t-50 17l-44 -4v66q18 4 49 4q64 0 96 -36t32 -101v-235q0 -54 51 -54h24v-64h-24q-51 0 -51 -54v-235q0 -65 -32 -101t-96 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    d: "M393 195q-43 0 -107 23t-98 23q-28 0 -50 -11.5t-30 -23.5l-8 -12l-54 38q2 3 5 8.5t15 19t27 24t40.5 19t55.5 8.5q44 0 107.5 -23t97.5 -23q28 0 50 11.5t30 23.5l8 12l53 -37q-1 -3 -4.5 -8.5t-15 -19.5t-26.5 -24.5t-40.5 -19t-55.5 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 247,
    d: "M94 346h59l12 -546h-83zM124 518q23 0 38 -15t15 -37q0 -23 -15 -38.5t-38 -15.5q-24 0 -39 15.5t-15 38.5t15 37.5t39 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    d: "M271 -17v109q-102 9 -163 85t-61 178q0 101 61 177.5t163 85.5v108h49v-108q86 -7 141 -61t71 -130h-73q-14 53 -49.5 86t-89.5 39v-395q54 6 89.5 39t49.5 87h73q-16 -77 -71 -131t-141 -60v-109h-49zM118 355q0 -80 42 -134.5t111 -63.5v395q-69 -9 -111 -63.5 t-42 -133.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    d: "M512 116l46 -40q-67 -91 -176 -91q-46 0 -113 24.5t-106 24.5q-26 0 -51 -12t-37 -24l-12 -11l-40 46q27 33 78 52q67 49 67 135q0 34 -13 66h-115v59h88q-2 4 -10.5 21.5t-12 25.5t-10 25.5t-10 30.5t-6 31t-2.5 36q0 92 59 151t167 59q106 0 166 -61t60 -165l-1 -25 h-73q2 11 2 23q0 74 -39 118t-115 44t-114.5 -41t-38.5 -109q0 -25 6 -50.5t10.5 -37t20 -42t17.5 -34.5h195v-59h-173q9 -27 9 -60q0 -77 -43 -129q38 -1 99.5 -23.5t104.5 -22.5q71 0 116 65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 600,
    d: "M113 252q0 60 34 106l-73 75l48 48l75 -75q47 34 104 34q56 0 103 -34l74 74l49 -48l-73 -73q35 -52 35 -107t-33 -104l71 -71l-49 -49l-71 70q-49 -34 -106 -34q-59 0 -108 35l-71 -71l-48 49l72 72q-33 46 -33 103zM172 252q0 -53 38 -91t91 -38t90.5 38t37.5 91 q0 52 -37.5 90t-90.5 38t-91 -37.5t-38 -90.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    d: "M35 710h78l177 -305h2l173 305h82l-213 -359h136v-58h-143v-85h143v-58h-143v-150h-73v150h-143v58h143v85h-143v58h135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 272,
    d: "M102 307h68v-307h-68v307zM102 749h68v-307h-68v307z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 564,
    d: "M54 295q0 52 29 91t75 58q-58 48 -58 125q0 68 51.5 112t136.5 44q52 0 91 -16t59.5 -43.5t30.5 -53.5t13 -55h-69q-6 47 -37 76.5t-90 29.5q-57 0 -86.5 -26t-29.5 -65q0 -73 101 -114l59 -25q94 -39 137 -82.5t43 -109.5q0 -53 -29 -92t-76 -59q59 -45 59 -123 q0 -69 -51 -112.5t-137 -43.5q-42 0 -76 11.5t-54.5 28.5t-34.5 40.5t-20 44.5t-8 43h68q7 -47 38 -76.5t89 -29.5q57 0 87 25.5t30 64.5q0 72 -101 115l-60 25q-93 40 -136.5 83.5t-43.5 108.5zM302 371l-89 38q-41 -12 -66.5 -41t-25.5 -69q0 -45 34 -73t108 -61l88 -39 q40 11 66.5 41t26.5 70q0 46 -34.5 74.5t-107.5 59.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 390,
    d: "M121 630q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5t34.5 -13.5t13.5 -34.5q0 -20 -13.5 -33.5t-34.5 -13.5zM269 630q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5q20 0 34 -13.5t14 -34.5q0 -20 -14 -33.5t-34 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 796,
    d: "M30 356q0 158 104 263.5t265 105.5q162 0 265.5 -105.5t103.5 -263.5t-103.5 -263.5t-265.5 -105.5q-161 0 -265 105.5t-104 263.5zM92 356q0 -138 85 -226t222 -88q138 0 223 88t85 226t-85 226t-223 88q-137 0 -222 -88t-85 -226zM213 356q0 84 52.5 140t133.5 56 t127.5 -45t52.5 -101h-62q-6 36 -35 63.5t-82 27.5q-59 0 -91.5 -39t-32.5 -102t32.5 -102.5t91.5 -39.5q53 0 82 27.5t35 64.5h62q-6 -56 -52.5 -101t-127.5 -45t-133.5 56t-52.5 140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 412,
    d: "M170 321q-64 0 -97 29t-33 79q0 101 165 122l91 12v10q0 81 -89 81q-83 0 -96 -74h-62q6 53 44 91t116 38q149 0 149 -143v-165q0 -16 2 -33.5t4 -27.5l2 -10h-61q-4 7 -6 47q-42 -56 -129 -56zM103 429q0 -56 78 -56q58 0 86.5 34t28.5 88v16l-66 -8q-66 -8 -96.5 -25.5 t-30.5 -48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 500,
    d: "M63 254l110 212h75l-110 -212l110 -211h-75zM252 254l109 212h76l-110 -212l110 -211h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    d: "M33 288h516v-246h-69v178h-447v68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 586,
    d: "M294 197q-116 0 -190 76.5t-74 187.5t74 187.5t190 76.5t190 -76.5t74 -187.5q0 -112 -74 -188t-190 -76zM294 246q95 0 153 59.5t58 155.5t-58 155.5t-153 59.5t-152.5 -59.5t-57.5 -155.5t57.5 -155.5t152.5 -59.5zM409 331h-58l-40 82q-10 -1 -17 -1h-44v-81h-50v259 h97q53 0 80.5 -24t27.5 -65q0 -55 -46 -77zM304 543h-54v-83h54q50 0 50 41q0 42 -50 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 397,
    d: "M359 697v-60h-321v60h321z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 384,
    d: "M27 562q0 68 47.5 115.5t116.5 47.5t116 -47.5t47 -115.5q0 -69 -47 -116.5t-116 -47.5t-116.5 47.5t-47.5 116.5zM88 562q0 -46 28 -77t75 -31t74.5 31t27.5 77q0 45 -27.5 76t-74.5 31t-75 -31t-28 -76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    d: "M257 509h69v-162h223v-69h-223v-161h-69v161h-224v69h224v162zM549 69v-69h-516v69h516z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 385,
    d: "M341 438h-292v47l170 151q28 26 41 48.5t13 54.5q0 38 -21 61t-59 23q-41 0 -62 -24.5t-21 -67.5l1 -15h-61q-1 8 -1 16q0 66 39 106.5t105 40.5q67 0 104.5 -39t37.5 -99q0 -79 -80 -147l-114 -99h200v-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 387,
    d: "M139 630v52h49q42 0 62.5 19.5t20.5 51.5q0 33 -20.5 51.5t-60.5 18.5q-37 0 -57.5 -21t-23.5 -55h-60q5 58 42.5 95t98.5 37q68 0 104.5 -33.5t36.5 -90.5q0 -68 -61 -96q33 -12 50.5 -39t17.5 -60q0 -59 -40 -95.5t-108 -36.5q-65 0 -103 37t-43 101h59q3 -38 26 -60 t61 -22t61.5 20t23.5 57q0 69 -88 69h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 349,
    d: "M168 759h77l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\xB5",
    horizAdvX: 586,
    d: "M293 -12q-84 0 -144 46q0 -16 1 -63t1 -74v-85h-69v697h71v-311q0 -70 36 -109t104 -39t104 39t36 109v311h71v-316q0 -90 -54 -147.5t-157 -57.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 613,
    d: "M284 -198v471q-116 0 -175.5 61t-59.5 157q0 95 63 157t172 62h227v-908h-69v841h-88v-841h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 216,
    d: "M108 203q-24 0 -39.5 15t-15.5 39q0 23 15.5 38.5t39.5 15.5q23 0 39 -15.5t16 -38.5q0 -24 -15.5 -39t-39.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 271,
    d: "M48 -212l25 40q21 -20 54 -20q24 0 39 13t15 35q0 48 -51 48q-13 0 -24.5 -5t-15.5 -9l-5 -5l-31 17l42 112h45l-27 -72q9 5 29 5q41 0 66 -25.5t25 -64.5q0 -43 -29.5 -69.5t-76.5 -26.5q-24 0 -44 6.5t-28 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 275,
    d: "M179 869v-432h-61v373h-91v47l106 12h46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 437,
    d: "M219 321q-84 0 -137.5 55t-53.5 139t53.5 139t137.5 55q83 0 136.5 -55t53.5 -139t-53.5 -139t-136.5 -55zM219 651q-59 0 -93 -38t-34 -98t34 -98t93 -38q58 0 92 38t34 98t-34 98t-92 38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 500,
    d: "M327 466l109 -212l-109 -211h-75l110 211l-110 212h75zM139 466l109 -212l-109 -211h-76l110 211l-110 212h76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 786,
    d: "M123 277v373h-91v47l106 12h46v-432h-61zM146 0l392 710h63l-392 -710h-63zM404 101v50l203 281h63v-276h56v-55h-56v-101h-59v101h-207zM471 156h140v194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 838,
    d: "M123 277v373h-91v47l106 12h46v-432h-61zM146 0l392 710h63l-392 -710h-63zM485 0v47l170 151q29 25 42 48t13 54q0 38 -21 61t-60 23q-40 0 -61 -24.5t-21 -66.5l1 -16h-62q-1 8 -1 17q0 66 39.5 106.5t104.5 40.5q67 0 105 -39t38 -99q0 -44 -19.5 -78t-60.5 -69 l-114 -99h200v-57h-293z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 863,
    d: "M60 401h60q3 -38 26 -60t61 -22t61.5 20t23.5 58q0 69 -89 69h-47v51h49q42 0 62.5 19.5t20.5 51.5q0 33 -20.5 51.5t-61.5 18.5q-37 0 -57 -21t-23 -55h-61q5 58 42.5 95t99.5 37q68 0 104.5 -33.5t36.5 -90.5q0 -30 -15.5 -56t-45.5 -39q33 -12 50.5 -39.5t17.5 -60.5 q0 -59 -40 -95.5t-108 -36.5q-65 0 -103.5 37.5t-43.5 100.5zM224 0l392 710h62l-392 -710h-62zM482 101v50l203 281h62v-276h56v-55h-56v-101h-58v101h-207zM548 156h141v194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 522,
    d: "M484 -4q0 -90 -59.5 -150.5t-158.5 -60.5q-103 0 -160 55.5t-57 142.5q0 49 20 90t48 69t56 52.5t48 52.5t20 58l-4 41h70q5 -24 5 -42q0 -41 -19.5 -75.5t-47.5 -59.5t-55.5 -50.5t-47 -59t-19.5 -72.5q0 -64 38.5 -100t104.5 -36q65 0 104.5 41t39.5 108l-3 39h74 q3 -20 3 -43zM268 518q24 0 39 -14.5t15 -37.5t-15 -38t-39 -15q-23 0 -38 15t-15 38q0 22 15 37t38 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 673,
    d: "M82 0h-78l292 710h79l293 -710h-81l-67 166h-370zM336 621h-2l-158 -387h317zM230 939h78l66 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 673,
    d: "M82 0h-78l292 710h79l293 -710h-81l-67 166h-370zM336 621h-2l-158 -387h317zM373 940h77l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 673,
    d: "M82 0h-78l292 710h79l293 -710h-81l-67 166h-370zM336 621h-2l-158 -387h317zM202 830l134 70l135 -70v-65l-135 68l-134 -68v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 673,
    d: "M82 0h-78l292 710h79l293 -710h-81l-67 166h-370zM336 621h-2l-158 -387h317zM399 788q-29 0 -70 20t-62 20q-35 0 -42 -36h-55q5 44 31.5 69t69.5 25q29 0 69.5 -19.5t61.5 -19.5q35 0 42 36h55q-5 -44 -31 -69.5t-69 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 673,
    d: "M82 0h-78l292 710h79l293 -710h-81l-67 166h-370zM336 621h-2l-158 -387h317zM261 767q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5t34.5 -13.5t13.5 -34.5q0 -20 -13.5 -33.5t-34.5 -13.5zM409 767q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5 q20 0 34 -13.5t14 -34.5q0 -20 -14 -33.5t-34 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 673,
    d: "M82 0h-78l292 710h79l293 -710h-81l-67 166h-370zM336 621h-2l-158 -387h317zM278 860q0 -27 16 -45t44 -18q27 0 43.5 18t16.5 45q0 26 -16.5 44.5t-43.5 18.5q-28 0 -44 -18t-16 -45zM226 860q0 47 31.5 78.5t80.5 31.5t79.5 -31.5t30.5 -78.5t-30.5 -79t-79.5 -32 t-80.5 32t-31.5 79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 986,
    d: "M63 0h-85l429 710h522v-69h-404v-246h382v-69h-382v-257h404v-69h-477v166h-289zM446 638l-244 -404h250v404h-6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 781,
    d: "M52 355q0 161 96.5 265.5t254.5 104.5q130 0 220 -72t115 -193h-77q-21 90 -91 143t-167 53q-124 0 -199.5 -83t-75.5 -218t75.5 -218t199.5 -83q97 0 167 53t91 143h77q-24 -117 -110 -189t-211 -76l-16 -43q9 5 29 5q41 0 66 -25.5t25 -64.5q0 -43 -29.5 -69.5 t-76.5 -26.5q-24 0 -44 6.5t-28 13.5l-8 7l25 40q21 -20 54 -20q24 0 39 13t15 35q0 48 -51 48q-13 0 -24.5 -5t-16.5 -9l-4 -5l-31 17l31 84q-145 10 -232.5 113t-87.5 256z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 636,
    d: "M578 69v-69h-477v710h477v-69h-404v-246h383v-69h-383v-257h404zM236 940h78l66 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 636,
    d: "M578 69v-69h-477v710h477v-69h-404v-246h383v-69h-383v-257h404zM366 940h77l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 636,
    d: "M578 69v-69h-477v710h477v-69h-404v-246h383v-69h-383v-257h404zM210 830l134 70l135 -70v-65l-135 68l-134 -68v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 636,
    d: "M578 69v-69h-477v710h477v-69h-404v-246h383v-69h-383v-257h404zM261 767q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5t34.5 -13.5t13.5 -34.5q0 -20 -13.5 -33.5t-34.5 -13.5zM409 767q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5q20 0 34 -13.5 t14 -34.5q0 -20 -14 -33.5t-34 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 276,
    d: "M174 710v-710h-73v710h73zM28 940h78l66 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 276,
    d: "M174 710v-710h-73v710h73zM172 940h77l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 276,
    d: "M174 710v-710h-73v710h73zM3 839l134 70l135 -70v-65l-135 68l-134 -68v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 276,
    d: "M174 710v-710h-73v710h73zM64 767q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5t34.5 -13.5t13.5 -34.5q0 -20 -13.5 -33.5t-34.5 -13.5zM212 767q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5q20 0 34 -13.5t14 -34.5q0 -20 -14 -33.5t-34 -13.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 763,
    d: "M316 0h-215v322h-82v66h82v322h215q186 0 290.5 -96t104.5 -259t-104.5 -259t-290.5 -96zM635 355q0 135 -82.5 210t-240.5 75h-138v-252h183v-66h-183v-252h138q158 0 240.5 75t82.5 210z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 766,
    d: "M174 593v-593h-73v710h77l414 -594v594h73v-710h-77zM453 766q-29 0 -70 20t-62 20q-35 0 -42 -36h-55q5 44 31.5 69t69.5 25q29 0 69.5 -19.5t61.5 -19.5q35 0 42 36h55q-5 -44 -31 -69.5t-69 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 828,
    d: "M128 355q0 -133 81 -217t205 -84t205 84t81 217t-81 217t-205 84t-205 -84t-81 -217zM776 355q0 -158 -100.5 -264t-261.5 -106t-261.5 106t-100.5 264t100.5 264t261.5 106t261.5 -106t100.5 -264zM308 940h78l66 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 828,
    d: "M128 355q0 -133 81 -217t205 -84t205 84t81 217t-81 217t-205 84t-205 -84t-81 -217zM776 355q0 -158 -100.5 -264t-261.5 -106t-261.5 106t-100.5 264t100.5 264t261.5 106t261.5 -106t100.5 -264zM444 940h77l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 828,
    d: "M128 355q0 -133 81 -217t205 -84t205 84t81 217t-81 217t-205 84t-205 -84t-81 -217zM776 355q0 -158 -100.5 -264t-261.5 -106t-261.5 106t-100.5 264t100.5 264t261.5 106t261.5 -106t100.5 -264zM278 846l134 70l135 -70v-65l-135 68l-134 -68v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 828,
    d: "M128 355q0 -133 81 -217t205 -84t205 84t81 217t-81 217t-205 84t-205 -84t-81 -217zM776 355q0 -158 -100.5 -264t-261.5 -106t-261.5 106t-100.5 264t100.5 264t261.5 106t261.5 -106t100.5 -264zM479 788q-29 0 -70 20t-62 20q-35 0 -42 -36h-55q5 44 31.5 69t69.5 25 q29 0 69.5 -19.5t61.5 -19.5q35 0 42 36h55q-5 -44 -31 -69.5t-69 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 828,
    d: "M128 355q0 -133 81 -217t205 -84t205 84t81 217t-81 217t-205 84t-205 -84t-81 -217zM776 355q0 -158 -100.5 -264t-261.5 -106t-261.5 106t-100.5 264t100.5 264t261.5 106t261.5 -106t100.5 -264zM343 787q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5 t34.5 -13.5t13.5 -34.5q0 -20 -13.5 -33.5t-34.5 -13.5zM491 787q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5q20 0 34 -13.5t14 -34.5q0 -20 -14 -33.5t-34 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    d: "M64 433l49 48l178 -178l177 177l49 -48l-178 -178l178 -177l-49 -49l-177 178l-178 -178l-49 48l178 178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 828,
    d: "M776 355q0 -158 -100.5 -264t-261.5 -106q-129 0 -220 69l-77 -92l-39 33l77 93q-103 105 -103 267q0 158 100.5 264t261.5 106q122 0 215 -67l75 90l39 -35l-74 -89q107 -105 107 -269zM699 355q0 130 -78 213l-380 -459q73 -56 173 -56q124 0 204.5 84.5t80.5 217.5z M128 355q0 -127 75 -210l379 458q-72 53 -168 53q-124 0 -205 -84t-81 -217z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 734,
    d: "M367 -15q-129 0 -205.5 79t-76.5 229v417h73v-424q0 -108 54.5 -171t154.5 -63t154.5 63t54.5 171v424h73v-417q0 -150 -77 -229t-205 -79zM257 940h78l66 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 734,
    d: "M367 -15q-129 0 -205.5 79t-76.5 229v417h73v-424q0 -108 54.5 -171t154.5 -63t154.5 63t54.5 171v424h73v-417q0 -150 -77 -229t-205 -79zM390 941h77l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 734,
    d: "M367 -15q-129 0 -205.5 79t-76.5 229v417h73v-424q0 -108 54.5 -171t154.5 -63t154.5 63t54.5 171v424h73v-417q0 -150 -77 -229t-205 -79zM231 839l134 70l135 -70v-65l-135 68l-134 -68v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 734,
    d: "M367 -15q-129 0 -205.5 79t-76.5 229v417h73v-424q0 -108 54.5 -171t154.5 -63t154.5 63t54.5 171v424h73v-417q0 -150 -77 -229t-205 -79zM293 767q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5t34.5 -13.5t13.5 -34.5q0 -20 -13.5 -33.5t-34.5 -13.5z M441 767q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5q20 0 34 -13.5t14 -34.5q0 -20 -14 -33.5t-34 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 615,
    d: "M530 710h85l-271 -458v-252h-73v252l-271 458h82l225 -381h2zM337 940h77l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 644,
    d: "M174 195v-195h-73v710h73v-105h203q117 0 173 -56.5t56 -148.5t-56.5 -148.5t-172.5 -56.5h-203zM174 264h206q76 0 113.5 35.5t37.5 100.5t-37.5 100.5t-113.5 35.5h-206v-272z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 612,
    d: "M562 149q0 -74 -47.5 -117t-123.5 -43q-88 0 -133.5 46.5t-48.5 107.5h70q2 -39 31.5 -65.5t79.5 -26.5q47 0 74 25.5t27 71.5q0 47 -53 89l-26 21q-62 48 -62 107q0 37 30 90l9 15q22 40 22 73q0 53 -33 82t-91 29q-63 0 -96 -39.5t-33 -111.5v-503h-71v496 q0 104 54 163.5t147 59.5q88 0 140 -48.5t52 -125.5q0 -50 -34 -107l-8 -14q-19 -34 -19 -55q0 -18 8 -29.5t31 -30.5l25 -21q79 -66 79 -139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 638,
    d: "M550 509v-509h-68v94q-57 -106 -193 -106q-112 0 -176 77.5t-64 188.5t64 189t176 78q136 0 193 -106v94h68zM121 254q0 -86 49.5 -144t132.5 -58t131 58t48 144q0 87 -48 145t-131 58t-132.5 -58.5t-49.5 -144.5zM204 759h78l66 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 638,
    d: "M550 509v-509h-68v94q-57 -106 -193 -106q-112 0 -176 77.5t-64 188.5t64 189t176 78q136 0 193 -106v94h68zM121 254q0 -86 49.5 -144t132.5 -58t131 58t48 144q0 87 -48 145t-131 58t-132.5 -58.5t-49.5 -144.5zM325 759h77l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 638,
    d: "M550 509v-509h-68v94q-57 -106 -193 -106q-112 0 -176 77.5t-64 188.5t64 189t176 78q136 0 193 -106v94h68zM121 254q0 -86 49.5 -144t132.5 -58t131 58t48 144q0 87 -48 145t-131 58t-132.5 -58.5t-49.5 -144.5zM171 664l134 70l135 -70v-65l-135 68l-134 -68v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 638,
    d: "M550 509v-509h-68v94q-57 -106 -193 -106q-112 0 -176 77.5t-64 188.5t64 189t176 78q136 0 193 -106v94h68zM121 254q0 -86 49.5 -144t132.5 -58t131 58t48 144q0 87 -48 145t-131 58t-132.5 -58.5t-49.5 -144.5zM368 622q-29 0 -70 20t-62 20q-35 0 -42 -36h-55 q5 44 31.5 69t69.5 25q29 0 69.5 -19.5t61.5 -19.5q35 0 42 36h55q-5 -44 -31 -69.5t-69 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 638,
    d: "M550 509v-509h-68v94q-57 -106 -193 -106q-112 0 -176 77.5t-64 188.5t64 189t176 78q136 0 193 -106v94h68zM121 254q0 -86 49.5 -144t132.5 -58t131 58t48 144q0 87 -48 145t-131 58t-132.5 -58.5t-49.5 -144.5zM239 630q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5 t34.5 13.5t34.5 -13.5t13.5 -34.5q0 -20 -13.5 -33.5t-34.5 -13.5zM387 630q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5q20 0 34 -13.5t14 -34.5q0 -20 -14 -33.5t-34 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 638,
    d: "M550 509v-509h-68v94q-57 -106 -193 -106q-112 0 -176 77.5t-64 188.5t64 189t176 78q136 0 193 -106v94h68zM121 254q0 -86 49.5 -144t132.5 -58t131 58t48 144q0 87 -48 145t-131 58t-132.5 -58.5t-49.5 -144.5zM250 695q0 -27 16 -45t44 -18q27 0 43.5 18t16.5 45 q0 26 -16.5 44.5t-43.5 18.5q-28 0 -44 -18t-16 -45zM198 695q0 47 31.5 78.5t80.5 31.5t79.5 -31.5t30.5 -78.5t-30.5 -79t-79.5 -32t-80.5 32t-31.5 79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 965,
    d: "M234 -12q-88 0 -135 40.5t-47 111.5q0 129 192 154l179 23v14q0 129 -145 129q-124 0 -144 -101h-69q11 74 63.5 118t152.5 44q147 0 192 -106q71 106 199 106q111 0 178 -74.5t67 -185.5l-1 -27h-423q5 -79 53.5 -130.5t126.5 -51.5q58 0 100.5 29.5t60.5 77.5h74 q-24 -76 -86 -123.5t-150 -47.5q-74 0 -129 34t-86 91q-26 -59 -85 -92t-138 -33zM240 47q86 0 134 46.5t48 108.5v59l-169 -23q-70 -9 -100.5 -33.5t-30.5 -64.5q0 -50 34 -71.5t84 -21.5zM672 457q-72 0 -120 -46.5t-57 -118.5h351q-8 75 -54 120t-120 45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 577,
    d: "M234 -211l25 39q20 -20 54 -20q24 0 38.5 13t14.5 35q0 48 -51 48q-13 0 -24 -5t-15 -9l-5 -5l-31 18l32 86q-101 10 -162 86.5t-61 178.5q0 109 69.5 188t181.5 79q98 0 160 -55.5t78 -137.5h-72q-16 60 -59 94.5t-107 34.5q-80 0 -129.5 -57t-49.5 -146 q0 -88 49.5 -145t129.5 -57q64 0 107 34.5t59 94.5h72q-16 -79 -73 -133t-149 -59l-17 -48q9 5 30 5q41 0 65 -25t24 -64q0 -42 -29.5 -68.5t-75.5 -26.5q-23 0 -43 7t-28 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 593,
    d: "M543 234h-423q5 -80 54 -131t127 -51q57 0 100 29.5t60 77.5h74q-23 -76 -85 -123.5t-150 -47.5q-116 0 -183.5 77.5t-67.5 189.5q0 110 69.5 188t180.5 78t178 -74.5t67 -185.5zM299 457q-72 0 -120 -46.5t-57 -118.5h351q-7 75 -53.5 120t-120.5 45zM199 759h78 l66 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 593,
    d: "M543 234h-423q5 -80 54 -131t127 -51q57 0 100 29.5t60 77.5h74q-23 -76 -85 -123.5t-150 -47.5q-116 0 -183.5 77.5t-67.5 189.5q0 110 69.5 188t180.5 78t178 -74.5t67 -185.5zM299 457q-72 0 -120 -46.5t-57 -118.5h351q-7 75 -53.5 120t-120.5 45zM331 759h77 l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 593,
    d: "M543 234h-423q5 -80 54 -131t127 -51q57 0 100 29.5t60 77.5h74q-23 -76 -85 -123.5t-150 -47.5q-116 0 -183.5 77.5t-67.5 189.5q0 110 69.5 188t180.5 78t178 -74.5t67 -185.5zM299 457q-72 0 -120 -46.5t-57 -118.5h351q-7 75 -53.5 120t-120.5 45zM171 664l134 70 l135 -70v-65l-135 68l-134 -68v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 593,
    d: "M543 234h-423q5 -80 54 -131t127 -51q57 0 100 29.5t60 77.5h74q-23 -76 -85 -123.5t-150 -47.5q-116 0 -183.5 77.5t-67.5 189.5q0 110 69.5 188t180.5 78t178 -74.5t67 -185.5zM299 457q-72 0 -120 -46.5t-57 -118.5h351q-7 75 -53.5 120t-120.5 45zM226 630 q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5t34.5 -13.5t13.5 -34.5q0 -20 -13.5 -33.5t-34.5 -13.5zM374 630q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5q20 0 34 -13.5t14 -34.5q0 -20 -14 -33.5t-34 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 246,
    d: "M16 759h78l66 -170h-66zM158 509v-509h-71v509h71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 246,
    d: "M153 759h77l-77 -170h-66zM158 509v-509h-71v509h71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 246,
    d: "M158 509v-509h-71v509h71zM-11 664l134 70l135 -70v-65l-135 68l-134 -68v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 246,
    d: "M49 630q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5t34.5 -13.5t13.5 -34.5q0 -20 -13.5 -33.5t-34.5 -13.5zM197 630q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5q20 0 34 -13.5t14 -34.5q0 -20 -14 -33.5t-34 -13.5zM158 509v-509h-71v509h71z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 614,
    d: "M205 581l-24 41l112 56q-36 25 -95 56l40 43q60 -31 113 -70l109 55l25 -42l-95 -47q174 -160 174 -403q0 -119 -71 -200.5t-187 -81.5q-115 0 -186 78.5t-71 187.5q0 110 69 188.5t183 78.5q56 0 103 -23t71 -57q-48 122 -141 204zM121 254q0 -86 51 -144t134 -58 q84 0 135 58t51 144q0 87 -51 145t-135 58q-83 0 -134 -58t-51 -145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 598,
    d: "M155 509v-78q18 34 60 62t108 28q92 0 142.5 -54t50.5 -142v-325h-71v311q0 71 -33.5 109.5t-100.5 38.5t-110 -41t-43 -115v-303h-71v509h68zM363 622q-29 0 -70 20t-62 20q-35 0 -42 -36h-55q5 44 31.5 69t69.5 25q29 0 69.5 -19.5t61.5 -19.5q35 0 42 36h55 q-5 -44 -31 -69.5t-69 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 617,
    d: "M308 -12q-116 0 -187.5 78.5t-71.5 187.5q0 110 71.5 188.5t187.5 78.5q117 0 188.5 -78.5t71.5 -188.5q0 -109 -71.5 -187.5t-188.5 -78.5zM121 254q0 -87 52 -144.5t135 -57.5q84 0 136 57.5t52 144.5q0 88 -52 145.5t-136 57.5t-135.5 -57.5t-51.5 -145.5zM210 759h78 l66 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 617,
    d: "M308 -12q-116 0 -187.5 78.5t-71.5 187.5q0 110 71.5 188.5t187.5 78.5q117 0 188.5 -78.5t71.5 -188.5q0 -109 -71.5 -187.5t-188.5 -78.5zM121 254q0 -87 52 -144.5t135 -57.5q84 0 136 57.5t52 144.5q0 88 -52 145.5t-136 57.5t-135.5 -57.5t-51.5 -145.5zM344 759h77 l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 617,
    d: "M308 -12q-116 0 -187.5 78.5t-71.5 187.5q0 110 71.5 188.5t187.5 78.5q117 0 188.5 -78.5t71.5 -188.5q0 -109 -71.5 -187.5t-188.5 -78.5zM121 254q0 -87 52 -144.5t135 -57.5q84 0 136 57.5t52 144.5q0 88 -52 145.5t-136 57.5t-135.5 -57.5t-51.5 -145.5zM184 664 l134 70l135 -70v-65l-135 68l-134 -68v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 617,
    d: "M308 -12q-116 0 -187.5 78.5t-71.5 187.5q0 110 71.5 188.5t187.5 78.5q117 0 188.5 -78.5t71.5 -188.5q0 -109 -71.5 -187.5t-188.5 -78.5zM121 254q0 -87 52 -144.5t135 -57.5q84 0 136 57.5t52 144.5q0 88 -52 145.5t-136 57.5t-135.5 -57.5t-51.5 -145.5zM372 622 q-29 0 -70 20t-62 20q-35 0 -42 -36h-55q5 44 31.5 69t69.5 25q29 0 69.5 -19.5t61.5 -19.5q35 0 42 36h55q-5 -44 -31 -69.5t-69 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 617,
    d: "M308 -12q-116 0 -187.5 78.5t-71.5 187.5q0 110 71.5 188.5t187.5 78.5q117 0 188.5 -78.5t71.5 -188.5q0 -109 -71.5 -187.5t-188.5 -78.5zM121 254q0 -87 52 -144.5t135 -57.5q84 0 136 57.5t52 144.5q0 88 -52 145.5t-136 57.5t-135.5 -57.5t-51.5 -145.5zM234 630 q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5t34.5 -13.5t13.5 -34.5q0 -20 -13.5 -33.5t-34.5 -13.5zM382 630q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5q20 0 34 -13.5t14 -34.5q0 -20 -14 -33.5t-34 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    d: "M291 37q-23 0 -37.5 14t-14.5 37t14.5 37.5t37.5 14.5t37.5 -14.5t14.5 -37.5q0 -22 -14.5 -36.5t-37.5 -14.5zM291 368q-23 0 -37.5 14.5t-14.5 37.5t14.5 37.5t37.5 14.5t37.5 -15t14.5 -37t-14.5 -37t-37.5 -15zM549 288v-68h-516v68h516z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 617,
    d: "M308 -12q-86 0 -151 46l-53 -63l-35 30l54 63q-74 76 -74 190q0 110 71.5 188.5t187.5 78.5q89 0 155 -50l63 75l35 -30l-63 -75q70 -76 70 -187q0 -109 -71.5 -187.5t-188.5 -78.5zM496 254q0 79 -43 133l-253 -303q48 -32 108 -32q84 0 136 57.5t52 144.5zM121 254 q0 -83 46 -137l253 304q-47 36 -112 36q-84 0 -135.5 -57.5t-51.5 -145.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 586,
    d: "M293 -12q-103 0 -157 57.5t-54 147.5v316h71v-311q0 -70 36 -109t104 -39t104 39t36 109v311h71v-316q0 -90 -54 -147.5t-157 -57.5zM181 759h78l66 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 593,
    d: "M293 -12q-103 0 -157 57.5t-54 147.5v316h71v-311q0 -70 36 -109t104 -39t104 39t36 109v311h71v-316q0 -90 -54 -147.5t-157 -57.5zM317 759h77l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 586,
    d: "M293 -12q-103 0 -157 57.5t-54 147.5v316h71v-311q0 -70 36 -109t104 -39t104 39t36 109v311h71v-316q0 -90 -54 -147.5t-157 -57.5zM153 664l134 70l135 -70v-65l-135 68l-134 -68v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 586,
    d: "M293 -12q-103 0 -157 57.5t-54 147.5v316h71v-311q0 -70 36 -109t104 -39t104 39t36 109v311h71v-316q0 -90 -54 -147.5t-157 -57.5zM212 630q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5t34.5 -13.5t13.5 -34.5q0 -20 -13.5 -33.5t-34.5 -13.5zM360 630 q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5q20 0 34 -13.5t14 -34.5q0 -20 -14 -33.5t-34 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 532,
    d: "M142 -208l87 208l-213 509h77l173 -427l175 427h75l-302 -717h-72zM300 759h77l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 637,
    d: "M158 89v-297h-71v957h71v-329q58 101 189 101q113 0 176.5 -77t63.5 -190q0 -111 -63.5 -188.5t-176.5 -77.5q-131 0 -189 101zM157 256q0 -89 46.5 -146.5t130.5 -57.5q83 0 132 57.5t49 144.5q0 88 -49 146t-132 58q-82 0 -129.5 -57.5t-47.5 -144.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 532,
    d: "M142 -208l87 208l-213 509h77l173 -427l175 427h75l-302 -717h-72zM193 630q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5t34.5 -13.5t13.5 -34.5q0 -20 -13.5 -33.5t-34.5 -13.5zM341 630q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5 q20 0 34 -13.5t14 -34.5q0 -20 -14 -33.5t-34 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 673,
    d: "M82 0h-78l292 710h79l293 -710h-81l-67 166h-370zM336 621h-2l-158 -387h317zM496 830v-60h-321v60h321z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 638,
    d: "M550 509v-509h-68v94q-57 -106 -193 -106q-112 0 -176 77.5t-64 188.5t64 189t176 78q136 0 193 -106v94h68zM121 254q0 -86 49.5 -144t132.5 -58t131 58t48 144q0 87 -48 145t-131 58t-132.5 -58.5t-49.5 -144.5zM469 697v-60h-321v60h321z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 673,
    d: "M82 0h-78l292 710h79l293 -710h-81l-67 166h-370zM336 621h-2l-158 -387h317zM336 817q37 0 58.5 20t21.5 57h57q0 -61 -37 -95.5t-100 -34.5t-100.5 34.5t-37.5 95.5h58q0 -37 21.5 -57t58.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 638,
    d: "M550 509v-509h-68v94q-57 -106 -193 -106q-112 0 -176 77.5t-64 188.5t64 189t176 78q136 0 193 -106v94h68zM121 254q0 -86 49.5 -144t132.5 -58t131 58t48 144q0 87 -48 145t-131 58t-132.5 -58.5t-49.5 -144.5zM306 648q37 0 58.5 20t21.5 57h57q0 -61 -37 -95.5 t-100 -34.5t-100.5 34.5t-37.5 95.5h58q0 -37 21.5 -57t58.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 673,
    d: "M669 -128l26 -41q-1 0 -5.5 -4.5t-11 -9t-16 -9.5t-23 -8.5t-28.5 -3.5q-47 0 -71.5 30t-24.5 73q0 77 64 122l-59 145h-370l-68 -166h-78l292 710h79l293 -710h-24q-71 -32 -71 -98q0 -23 12.5 -38.5t35.5 -15.5q10 0 19.5 3.5t15 8t9.5 8.5zM336 621h-2l-158 -387h317z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 638,
    d: "M568 -127l26 -41q-1 0 -5.5 -4.5t-11 -9t-16 -9.5t-23 -8.5t-28.5 -3.5q-47 0 -71.5 30t-24.5 73q0 80 68 124v70q-57 -106 -193 -106q-112 0 -176 77.5t-64 188.5t64 189t176 78q136 0 193 -106v94h68v-509h-9q-69 -32 -69 -97q0 -23 12.5 -38.5t35.5 -15.5 q10 0 19.5 3.5t15 8t9.5 8.5zM121 254q0 -86 49.5 -144t132.5 -58t131 58t48 144q0 87 -48 145t-131 58t-132.5 -58.5t-49.5 -144.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 781,
    d: "M52 355q0 161 96.5 265.5t254.5 104.5q130 0 220 -72t115 -193h-77q-21 90 -91 143t-167 53q-124 0 -199.5 -83t-75.5 -218t75.5 -218t199.5 -83q97 0 167 53t91 143h77q-25 -121 -115 -193t-220 -72q-158 0 -254.5 104.5t-96.5 265.5zM431 940h77l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 577,
    d: "M49 254q0 109 69.5 188t181.5 79q98 0 160 -55.5t78 -137.5h-72q-16 60 -59 94.5t-107 34.5q-80 0 -129.5 -57t-49.5 -146q0 -88 49.5 -145t129.5 -57q64 0 107 34.5t59 94.5h72q-16 -82 -78 -137.5t-160 -55.5q-112 0 -181.5 78.5t-69.5 187.5zM324 759h77l-77 -170h-66 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccircumflex",
    unicode: "\u0108",
    horizAdvX: 781,
    d: "M52 355q0 161 96.5 265.5t254.5 104.5q130 0 220 -72t115 -193h-77q-21 90 -91 143t-167 53q-124 0 -199.5 -83t-75.5 -218t75.5 -218t199.5 -83q97 0 167 53t91 143h77q-25 -121 -115 -193t-220 -72q-158 0 -254.5 104.5t-96.5 265.5zM264 838l134 70l135 -70v-65 l-135 68l-134 -68v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccircumflex",
    unicode: "\u0109",
    horizAdvX: 577,
    d: "M49 254q0 109 69.5 188t181.5 79q98 0 160 -55.5t78 -137.5h-72q-16 60 -59 94.5t-107 34.5q-80 0 -129.5 -57t-49.5 -146q0 -88 49.5 -145t129.5 -57q64 0 107 34.5t59 94.5h72q-16 -82 -78 -137.5t-160 -55.5q-112 0 -181.5 78.5t-69.5 187.5zM167 664l134 70l135 -70 v-65l-135 68l-134 -68v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 781,
    d: "M52 355q0 161 96.5 265.5t254.5 104.5q130 0 220 -72t115 -193h-77q-21 90 -91 143t-167 53q-124 0 -199.5 -83t-75.5 -218t75.5 -218t199.5 -83q97 0 167 53t91 143h77q-25 -121 -115 -193t-220 -72q-158 0 -254.5 104.5t-96.5 265.5zM399 775q-22 0 -36.5 14t-14.5 36 q0 23 14 37t37 14q22 0 36.5 -14.5t14.5 -36.5t-14.5 -36t-36.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 577,
    d: "M49 254q0 109 69.5 188t181.5 79q98 0 160 -55.5t78 -137.5h-72q-16 60 -59 94.5t-107 34.5q-80 0 -129.5 -57t-49.5 -146q0 -88 49.5 -145t129.5 -57q64 0 107 34.5t59 94.5h72q-16 -82 -78 -137.5t-160 -55.5q-112 0 -181.5 78.5t-69.5 187.5zM291 627q-22 0 -36.5 14 t-14.5 36q0 23 14 37t37 14q22 0 36.5 -14.5t14.5 -36.5t-14.5 -36t-36.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 781,
    d: "M52 355q0 161 96.5 265.5t254.5 104.5q130 0 220 -72t115 -193h-77q-21 90 -91 143t-167 53q-124 0 -199.5 -83t-75.5 -218t75.5 -218t199.5 -83q97 0 167 53t91 143h77q-25 -121 -115 -193t-220 -72q-158 0 -254.5 104.5t-96.5 265.5zM404 766l-134 70v65l134 -67 l135 67v-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 577,
    d: "M49 254q0 109 69.5 188t181.5 79q98 0 160 -55.5t78 -137.5h-72q-16 60 -59 94.5t-107 34.5q-80 0 -129.5 -57t-49.5 -146q0 -88 49.5 -145t129.5 -57q64 0 107 34.5t59 94.5h72q-16 -82 -78 -137.5t-160 -55.5q-112 0 -181.5 78.5t-69.5 187.5zM301 591l-134 70v65 l134 -67l135 67v-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 763,
    d: "M316 0h-215v710h215q186 0 290.5 -96t104.5 -259t-104.5 -259t-290.5 -96zM635 355q0 135 -82.5 210t-240.5 75h-138v-570h138q158 0 240.5 75t82.5 210zM344 766l-134 70v65l134 -67l135 67v-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 638,
    d: "M479 417v333h71v-750h-68v94q-57 -106 -193 -106q-112 0 -176 77.5t-64 188.5q0 112 64 189.5t176 77.5q132 0 190 -104zM482 254q0 88 -48 145.5t-131 57.5t-132.5 -58t-49.5 -145q0 -86 49.5 -144t132.5 -58t131 58t48 144zM641 679q0 34 -23 57l57 20q29 -27 29 -75 q0 -27 -7.5 -51t-18 -39t-21 -26.5t-17.5 -16.5l-8 -5l-39 46q5 3 13 9.5t21.5 30t13.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 763,
    d: "M316 0h-215v322h-82v66h82v322h215q186 0 290.5 -96t104.5 -259t-104.5 -259t-290.5 -96zM635 355q0 135 -82.5 210t-240.5 75h-138v-252h183v-66h-183v-252h138q158 0 240.5 75t82.5 210z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    horizAdvX: 638,
    d: "M479 417v171h-165v60h165v102h71v-102h77v-60h-77v-588h-68v94q-57 -106 -193 -106q-112 0 -176 77.5t-64 188.5q0 112 64 189.5t176 77.5q132 0 190 -104zM482 254q0 88 -48 145.5t-131 57.5t-132.5 -58t-49.5 -145q0 -86 49.5 -144t132.5 -58t131 58t48 144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 636,
    d: "M578 69v-69h-477v710h477v-69h-404v-246h383v-69h-383v-257h404zM500 830v-60h-321v60h321z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 593,
    d: "M543 234h-423q5 -80 54 -131t127 -51q57 0 100 29.5t60 77.5h74q-23 -76 -85 -123.5t-150 -47.5q-116 0 -183.5 77.5t-67.5 189.5q0 110 69.5 188t180.5 78t178 -74.5t67 -185.5zM299 457q-72 0 -120 -46.5t-57 -118.5h351q-7 75 -53.5 120t-120.5 45zM461 697v-60h-321 v60h321z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 636,
    d: "M578 69v-69h-477v710h477v-69h-404v-246h383v-69h-383v-257h404zM335 817q37 0 58.5 20t21.5 57h57q0 -61 -37 -95.5t-100 -34.5t-100.5 34.5t-37.5 95.5h58q0 -37 21.5 -57t58.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 593,
    d: "M543 234h-423q5 -80 54 -131t127 -51q57 0 100 29.5t60 77.5h74q-23 -76 -85 -123.5t-150 -47.5q-116 0 -183.5 77.5t-67.5 189.5q0 110 69.5 188t180.5 78t178 -74.5t67 -185.5zM299 457q-72 0 -120 -46.5t-57 -118.5h351q-7 75 -53.5 120t-120.5 45zM299 648 q37 0 58.5 20t21.5 57h57q0 -61 -37 -95.5t-100 -34.5t-100.5 34.5t-37.5 95.5h58q0 -37 21.5 -57t58.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 636,
    d: "M578 69v-69h-477v710h477v-69h-404v-246h383v-69h-383v-257h404zM341 775q-22 0 -36.5 14t-14.5 36q0 23 14 37t37 14q22 0 36.5 -14.5t14.5 -36.5t-14.5 -36t-36.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 593,
    d: "M543 234h-423q5 -80 54 -131t127 -51q57 0 100 29.5t60 77.5h74q-23 -76 -85 -123.5t-150 -47.5q-116 0 -183.5 77.5t-67.5 189.5q0 110 69.5 188t180.5 78t178 -74.5t67 -185.5zM299 457q-72 0 -120 -46.5t-57 -118.5h351q-7 75 -53.5 120t-120.5 45zM299 627 q-22 0 -36.5 14t-14.5 36q0 23 14 37t37 14q22 0 36.5 -14.5t14.5 -36.5t-14.5 -36t-36.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 636,
    d: "M543 -127l26 -41q-1 0 -5.5 -4.5t-11 -9t-16 -9.5t-23 -8.5t-28.5 -3.5q-47 0 -71.5 30t-24.5 73q0 58 39 100h-327v710h477v-69h-404v-246h383v-69h-383v-257h404v-69h-62q-69 -32 -69 -97q0 -23 12.5 -38.5t35.5 -15.5q10 0 19.5 3.5t15 8t9.5 8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 593,
    d: "M386 -130l26 -41q-1 0 -5.5 -4.5t-11 -9t-16 -9.5t-23 -8.5t-28.5 -3.5q-47 0 -71.5 30t-24.5 73q0 54 33 93q-101 12 -158.5 86.5t-57.5 178.5q0 110 69.5 188t180.5 78t178 -74.5t67 -185.5l-1 -27h-423q5 -80 54 -131t127 -51q57 0 100 29.5t60 77.5h74 q-20 -64 -68 -109t-116 -57q-61 -33 -61 -93q0 -23 12.5 -38.5t35.5 -15.5q10 0 19.5 3.5t15 8t9.5 8.5zM299 457q-72 0 -120 -46.5t-57 -118.5h351q-7 75 -53.5 120t-120.5 45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 636,
    d: "M578 69v-69h-477v710h477v-69h-404v-246h383v-69h-383v-257h404zM339 766l-134 70v65l134 -67l135 67v-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 593,
    d: "M543 234h-423q5 -80 54 -131t127 -51q57 0 100 29.5t60 77.5h74q-23 -76 -85 -123.5t-150 -47.5q-116 0 -183.5 77.5t-67.5 189.5q0 110 69.5 188t180.5 78t178 -74.5t67 -185.5zM299 457q-72 0 -120 -46.5t-57 -118.5h351q-7 75 -53.5 120t-120.5 45zM299 591l-134 70 v65l134 -67l135 67v-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcircumflex",
    unicode: "\u011C",
    horizAdvX: 818,
    d: "M450 311v68h315q1 -15 1 -24q0 -158 -98.5 -264t-258.5 -106t-258.5 106t-98.5 264t98.5 264t258.5 106q129 0 218 -67.5t122 -183.5h-79q-30 86 -99 134t-162 48q-124 0 -202.5 -83.5t-78.5 -217.5t78.5 -217.5t202.5 -83.5q113 0 189 70.5t89 186.5h-237zM267 839 l134 70l135 -70v-65l-135 68l-134 -68v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex",
    unicode: "\u011D",
    horizAdvX: 632,
    d: "M481 416v93h68v-484q0 -108 -61.5 -176t-176.5 -68q-100 0 -158.5 48t-73.5 114h73q15 -45 57.5 -71.5t103.5 -26.5q77 0 121 45.5t44 118.5v95q-59 -103 -189 -103q-110 0 -175 76t-65 184t65 184t175 76q133 0 192 -105zM481 261q0 85 -48.5 140.5t-130.5 55.5 t-131.5 -56t-49.5 -140t49.5 -140.5t131.5 -56.5t130.5 56t48.5 141zM179 664l134 70l135 -70v-65l-135 68l-134 -68v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 818,
    d: "M450 311v68h315q1 -15 1 -24q0 -158 -98.5 -264t-258.5 -106t-258.5 106t-98.5 264t98.5 264t258.5 106q129 0 218 -67.5t122 -183.5h-79q-30 86 -99 134t-162 48q-124 0 -202.5 -83.5t-78.5 -217.5t78.5 -217.5t202.5 -83.5q113 0 189 70.5t89 186.5h-237zM402 818 q37 0 58.5 20t21.5 57h57q0 -61 -37 -95.5t-100 -34.5t-100.5 34.5t-37.5 95.5h58q0 -37 21.5 -57t58.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 632,
    d: "M481 416v93h68v-484q0 -108 -61.5 -176t-176.5 -68q-100 0 -158.5 48t-73.5 114h73q15 -45 57.5 -71.5t103.5 -26.5q77 0 121 45.5t44 118.5v95q-59 -103 -189 -103q-110 0 -175 76t-65 184t65 184t175 76q133 0 192 -105zM481 261q0 85 -48.5 140.5t-130.5 55.5 t-131.5 -56t-49.5 -140t49.5 -140.5t131.5 -56.5t130.5 56t48.5 141zM316 648q37 0 58.5 20t21.5 57h57q0 -61 -37 -95.5t-100 -34.5t-100.5 34.5t-37.5 95.5h58q0 -37 21.5 -57t58.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 818,
    d: "M450 311v68h315q1 -15 1 -24q0 -158 -98.5 -264t-258.5 -106t-258.5 106t-98.5 264t98.5 264t258.5 106q129 0 218 -67.5t122 -183.5h-79q-30 86 -99 134t-162 48q-124 0 -202.5 -83.5t-78.5 -217.5t78.5 -217.5t202.5 -83.5q113 0 189 70.5t89 186.5h-237zM404 775 q-22 0 -36.5 14t-14.5 36q0 23 14.5 37t36.5 14t36.5 -14.5t14.5 -36.5t-14.5 -36t-36.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 632,
    d: "M481 416v93h68v-484q0 -108 -61.5 -176t-176.5 -68q-100 0 -158.5 48t-73.5 114h73q15 -45 57.5 -71.5t103.5 -26.5q77 0 121 45.5t44 118.5v95q-59 -103 -189 -103q-110 0 -175 76t-65 184t65 184t175 76q133 0 192 -105zM481 261q0 85 -48.5 140.5t-130.5 55.5 t-131.5 -56t-49.5 -140t49.5 -140.5t131.5 -56.5t130.5 56t48.5 141zM314 627q-22 0 -36.5 14t-14.5 36q0 23 14.5 37t36.5 14t36.5 -14.5t14.5 -36.5t-14.5 -36t-36.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcommaaccent",
    unicode: "\u0122",
    horizAdvX: 818,
    d: "M450 311v68h315q1 -15 1 -24q0 -158 -98.5 -264t-258.5 -106t-258.5 106t-98.5 264t98.5 264t258.5 106q129 0 218 -67.5t122 -183.5h-79q-30 86 -99 134t-162 48q-124 0 -202.5 -83.5t-78.5 -217.5t78.5 -217.5t202.5 -83.5q113 0 189 70.5t89 186.5h-237zM381 -116 q0 21 -8.5 36.5t-14.5 20.5l57 20q29 -27 29 -75q0 -27 -7.5 -51t-18 -39t-21 -26.5t-17.5 -16.5l-8 -5l-39 46q5 3 13 9.5t21.5 30t13.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcommaaccent",
    unicode: "\u0123",
    horizAdvX: 632,
    d: "M481 416v93h68v-484q0 -108 -61.5 -176t-176.5 -68q-100 0 -158.5 48t-73.5 114h73q15 -45 57.5 -71.5t103.5 -26.5q77 0 121 45.5t44 118.5v95q-59 -103 -189 -103q-110 0 -175 76t-65 184t65 184t175 76q133 0 192 -105zM481 261q0 85 -48.5 140.5t-130.5 55.5 t-131.5 -56t-49.5 -140t49.5 -140.5t131.5 -56.5t130.5 56t48.5 141zM333 668q0 -36 21 -57l-55 -20q-29 27 -29 75q0 27 7.5 51t18 39t21 26.5t17.5 16.5l8 5l39 -46q-5 -3 -13 -9.5t-21.5 -30t-13.5 -50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hcircumflex",
    unicode: "\u0124",
    horizAdvX: 764,
    d: "M662 710v-710h-73v326h-415v-326h-73v710h73v-315h415v315h73zM246 830l134 70l135 -70v-65l-135 68l-134 -68v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hcircumflex",
    unicode: "\u0125",
    horizAdvX: 598,
    d: "M158 750v-312q18 31 60 57t105 26q92 0 142.5 -54t50.5 -142v-325h-71v311q0 71 -33.5 109.5t-100.5 38.5t-110 -41.5t-43 -116.5v-301h-71v750h71zM-11 829l134 70l135 -70v-65l-135 68l-134 -68v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 764,
    d: "M662 710v-143h60v-62h-60v-505h-73v326h-415v-326h-73v505h-60v62h60v143h73v-143h415v143h73zM174 395h415v110h-415v-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 598,
    d: "M158 750v-102h166v-60h-166v-150q18 31 60 57t105 26q92 0 142.5 -54t50.5 -142v-325h-71v311q0 71 -33.5 109.5t-100.5 38.5t-110 -41.5t-43 -116.5v-301h-71v588h-77v60h77v102h71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 276,
    d: "M174 710v-710h-73v710h73zM203 766q-29 0 -70 20t-62 20q-35 0 -42 -36h-55q5 44 31.5 69t69.5 25q29 0 69.5 -19.5t61.5 -19.5q35 0 42 36h55q-5 -44 -31 -69.5t-69 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 246,
    d: "M188 622q-29 0 -70 20t-62 20q-35 0 -42 -36h-55q5 44 31.5 69t69.5 25q29 0 69.5 -19.5t61.5 -19.5q35 0 42 36h55q-5 -44 -31 -69.5t-69 -25.5zM158 509v-509h-71v509h71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 276,
    d: "M174 710v-710h-73v710h73zM298 830v-60h-321v60h321z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 246,
    d: "M284 697v-60h-321v60h321zM158 509v-509h-71v509h71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 276,
    d: "M174 710v-710h-73v710h73zM138 818q37 0 58.5 20t21.5 57h57q0 -61 -37 -95.5t-100 -34.5t-100.5 34.5t-37.5 95.5h58q0 -37 21.5 -57t58.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 246,
    d: "M123 648q37 0 58.5 20t21.5 57h57q0 -61 -37 -95.5t-100 -34.5t-100.5 34.5t-37.5 95.5h58q0 -37 21.5 -57t58.5 -20zM158 509v-509h-71v509h71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 276,
    d: "M177 -127l26 -41q-1 0 -5.5 -4.5t-11 -9t-16 -9.5t-23 -8.5t-28.5 -3.5q-47 0 -71.5 30t-24.5 73q0 86 78 131v679h73v-710h-24q-69 -32 -69 -97q0 -23 12.5 -38.5t35.5 -15.5q10 0 19.5 3.5t15 8t9.5 8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 246,
    d: "M174 -127l26 -41q-1 0 -5.5 -4.5t-11 -9t-16 -9.5t-23 -8.5t-28.5 -3.5q-47 0 -71.5 30t-24.5 73q0 78 67 124v485h71v-509h-11q-69 -32 -69 -97q0 -23 12.5 -38.5t35.5 -15.5q10 0 19.5 3.5t15 8t9.5 8.5zM123 635q-23 0 -37 13.5t-14 35.5t14 36.5t37 14.5 q22 0 36.5 -14.5t14.5 -36.5t-14.5 -35.5t-36.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 276,
    d: "M174 710v-710h-73v710h73zM137 775q-22 0 -36.5 14t-14.5 36q0 23 14 37t37 14q22 0 36.5 -14.5t14.5 -36.5t-14.5 -36t-36.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 246,
    d: "M158 509v-509h-71v509h71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Jcircumflex",
    unicode: "\u0134",
    horizAdvX: 593,
    d: "M429 221v489h73v-487q0 -108 -61 -172t-167 -64q-105 0 -166 61t-61 165l2 44h74q-2 -17 -2 -44q0 -71 40 -115.5t113 -44.5q74 0 114.5 44t40.5 124zM332 839l134 70l135 -70v-65l-135 68l-134 -68v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "jcircumflex",
    unicode: "\u0135",
    horizAdvX: 246,
    d: "M-11 664l135 70l134 -70v-65l-134 68l-135 -68v65zM87 -208v717h71v-717h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kcommaaccent",
    unicode: "\u0136",
    horizAdvX: 703,
    d: "M700 0h-93l-278 362l-155 -152v-210h-73v710h73v-409l408 409h98l-300 -296zM345 -116q0 21 -8.5 36.5t-14.5 20.5l57 20q29 -27 29 -75q0 -27 -7.5 -51t-18 -39t-21 -26.5t-17.5 -16.5l-8 -5l-39 46q5 3 13 9.5t21.5 30t13.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kcommaaccent",
    unicode: "\u0137",
    horizAdvX: 553,
    d: "M439 509h95l-211 -210l227 -299h-88l-189 251l-115 -112v-139h-71v750h71v-524zM287 -116q0 21 -8.5 36.5t-14.5 20.5l57 20q29 -27 29 -75q0 -27 -7.5 -51t-18 -39t-21 -26.5t-17.5 -16.5l-8 -5l-39 46q5 3 13 9.5t21.5 30t13.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 541,
    d: "M530 69v-69h-429v710h73v-641h356zM169 940h77l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 246,
    d: "M158 0h-71v750h71v-750zM154 980h77l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcommaaccent",
    unicode: "\u013B",
    horizAdvX: 541,
    d: "M530 69v-69h-429v710h73v-641h356zM310 -116q0 21 -8.5 36.5t-14.5 20.5l57 20q29 -27 29 -75q0 -27 -7.5 -51t-18 -39t-21 -26.5t-18.5 -16.5l-7 -5l-39 46q5 3 13 9.5t21.5 30t13.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcommaaccent",
    unicode: "\u013C",
    horizAdvX: 246,
    d: "M158 0h-71v750h71v-750zM107 -116q0 21 -8.5 36.5t-14.5 20.5l57 20q29 -27 29 -75q0 -27 -7.5 -51t-18 -39t-21 -26.5t-17.5 -16.5l-8 -5l-39 46q5 3 13 9.5t21.5 30t13.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 541,
    d: "M530 69v-69h-429v710h73v-641h356zM330 648q0 34 -23 57l57 20q29 -27 29 -75q0 -27 -7.5 -51t-18 -39t-21 -26.5t-18.5 -16.5l-7 -5l-39 46q5 3 13 9.5t21.5 30t13.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 246,
    d: "M158 0h-71v750h71v-750zM249 679q0 34 -23 57l57 20q29 -27 29 -75q0 -27 -7.5 -51t-18 -39t-21 -26.5t-17.5 -16.5l-8 -5l-39 46q5 3 13 9.5t21.5 30t13.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 541,
    d: "M530 69v-69h-429v279l-89 -25v63l89 25v368h73v-348l125 35v-63l-125 -35v-230h356z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 246,
    d: "M159 0h-71v277l-81 -23v62l81 23v411h71v-390l81 23v-62l-81 -23v-298z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 766,
    d: "M174 593v-593h-73v710h77l414 -594v594h73v-710h-77zM416 940h77l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 598,
    d: "M155 509v-78q18 34 60 62t108 28q92 0 142.5 -54t50.5 -142v-325h-71v311q0 71 -33.5 109.5t-100.5 38.5t-110 -41t-43 -115v-303h-71v509h68zM323 759h77l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncommaaccent",
    unicode: "\u0145",
    horizAdvX: 766,
    d: "M174 593v-593h-73v710h77l414 -594v594h73v-710h-77zM369 -116q0 21 -8.5 36.5t-14.5 20.5l57 20q29 -27 29 -75q0 -27 -7.5 -51t-18 -39t-21 -26.5t-17.5 -16.5l-8 -5l-39 46q5 3 13 9.5t21.5 30t13.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncommaaccent",
    unicode: "\u0146",
    horizAdvX: 598,
    d: "M155 509v-78q18 34 60 62t108 28q92 0 142.5 -54t50.5 -142v-325h-71v311q0 71 -33.5 109.5t-100.5 38.5t-110 -41t-43 -115v-303h-71v509h68zM290 -116q0 21 -8.5 36.5t-14.5 20.5l57 20q29 -27 29 -75q0 -27 -7.5 -51t-18 -39t-21 -26.5t-18.5 -16.5l-7 -5l-39 46 q5 3 13 9.5t21.5 30t13.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 766,
    d: "M174 593v-593h-73v710h77l414 -594v594h73v-710h-77zM385 764l-134 70v65l134 -67l135 67v-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 598,
    d: "M155 509v-78q18 34 60 62t108 28q92 0 142.5 -54t50.5 -142v-325h-71v311q0 71 -33.5 109.5t-100.5 38.5t-110 -41t-43 -115v-303h-71v509h68zM298 591l-134 70v65l134 -67l135 67v-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 766,
    d: "M592 2l-418 589v-591h-73v710h77l414 -584v584h73v-682q0 -101 -46.5 -163.5t-140.5 -76.5l-19 61q68 12 98.5 48t34.5 105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 598,
    d: "M445 31v280q0 71 -33.5 109.5t-100.5 38.5t-110 -41t-43 -115v-303h-71v509h68v-78q18 34 60 62t108 28q92 0 142.5 -54t50.5 -142v-279q0 -91 -41.5 -152.5t-124.5 -80.5l-22 59q117 30 117 159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 828,
    d: "M128 355q0 -133 81 -217t205 -84t205 84t81 217t-81 217t-205 84t-205 -84t-81 -217zM776 355q0 -158 -100.5 -264t-261.5 -106t-261.5 106t-100.5 264t100.5 264t261.5 106t261.5 -106t100.5 -264zM574 831v-60h-321v60h321z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 617,
    d: "M308 -12q-116 0 -187.5 78.5t-71.5 187.5q0 110 71.5 188.5t187.5 78.5q117 0 188.5 -78.5t71.5 -188.5q0 -109 -71.5 -187.5t-188.5 -78.5zM121 254q0 -87 52 -144.5t135 -57.5q84 0 136 57.5t52 144.5q0 88 -52 145.5t-136 57.5t-135.5 -57.5t-51.5 -145.5zM470 697 v-60h-321v60h321z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 828,
    d: "M128 355q0 -133 81 -217t205 -84t205 84t81 217t-81 217t-205 84t-205 -84t-81 -217zM776 355q0 -158 -100.5 -264t-261.5 -106t-261.5 106t-100.5 264t100.5 264t261.5 106t261.5 -106t100.5 -264zM414 817q37 0 58.5 20t21.5 57h57q0 -61 -37 -95.5t-100 -34.5 t-100.5 34.5t-37.5 95.5h58q0 -37 21.5 -57t58.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 617,
    d: "M308 -12q-116 0 -187.5 78.5t-71.5 187.5q0 110 71.5 188.5t187.5 78.5q117 0 188.5 -78.5t71.5 -188.5q0 -109 -71.5 -187.5t-188.5 -78.5zM121 254q0 -87 52 -144.5t135 -57.5q84 0 136 57.5t52 144.5q0 88 -52 145.5t-136 57.5t-135.5 -57.5t-51.5 -145.5zM308 648 q37 0 58.5 20t21.5 57h57q0 -61 -37 -95.5t-100 -34.5t-100.5 34.5t-37.5 95.5h58q0 -37 21.5 -57t58.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 828,
    d: "M128 355q0 -133 81 -217t205 -84t205 84t81 217t-81 217t-205 84t-205 -84t-81 -217zM776 355q0 -158 -100.5 -264t-261.5 -106t-261.5 106t-100.5 264t100.5 264t261.5 106t261.5 -106t100.5 -264zM364 940h81l-85 -170h-61zM514 940h81l-86 -170h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 617,
    d: "M308 -12q-116 0 -187.5 78.5t-71.5 187.5q0 110 71.5 188.5t187.5 78.5q117 0 188.5 -78.5t71.5 -188.5q0 -109 -71.5 -187.5t-188.5 -78.5zM121 254q0 -87 52 -144.5t135 -57.5q84 0 136 57.5t52 144.5q0 88 -52 145.5t-136 57.5t-135.5 -57.5t-51.5 -145.5zM256 749h81 l-85 -170h-61zM406 749h81l-86 -170h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 1233,
    d: "M1175 69v-69h-477v136q-44 -72 -117 -111.5t-168 -39.5q-157 0 -259 106t-102 264t102 264t259 106q95 0 168 -40t117 -113v138h477v-69h-404v-246h382v-69h-382v-257h404zM413 657q-125 0 -205 -84t-80 -218t80 -218.5t205 -84.5t205 84.5t80 218.5t-80 218t-205 84z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 1038,
    d: "M308 -12q-116 0 -187.5 78.5t-71.5 187.5q0 110 71.5 188.5t187.5 78.5q75 0 132.5 -35.5t89.5 -94.5q31 59 87 94.5t128 35.5q111 0 178 -74.5t67 -185.5l-1 -27h-423q5 -79 53.5 -130.5t126.5 -51.5q57 0 100 29.5t60 77.5h74q-23 -76 -85 -123.5t-150 -47.5 q-149 0 -216 128q-31 -58 -88.5 -93t-132.5 -35zM568 292h350q-7 74 -53.5 119.5t-119.5 45.5q-72 0 -120 -46.5t-57 -118.5zM308 52q84 0 136 57.5t52 144.5q0 88 -52 145.5t-136 57.5t-135.5 -57.5t-51.5 -145.5q0 -87 52 -144.5t135 -57.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 672,
    d: "M637 0h-88l-167 309h-208v-309h-73v710h292q115 0 171.5 -55.5t56.5 -144.5q0 -75 -40.5 -127t-122.5 -67zM545 510q0 60 -37.5 95t-111.5 35h-222v-261h222q74 0 111.5 34.5t37.5 96.5zM359 940h77l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 351,
    d: "M335 513v-67q-12 1 -25 1q-68 0 -110 -40.5t-42 -117.5v-289h-71v509h68v-79q18 33 59 58.5t104 25.5zM218 759h77l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcommaaccent",
    unicode: "\u0156",
    horizAdvX: 672,
    d: "M637 0h-88l-167 309h-208v-309h-73v710h292q115 0 171.5 -55.5t56.5 -144.5q0 -75 -40.5 -127t-122.5 -67zM545 510q0 60 -37.5 95t-111.5 35h-222v-261h222q74 0 111.5 34.5t37.5 96.5zM330 -116q0 21 -8.5 36.5t-14.5 20.5l57 20q29 -27 29 -75q0 -27 -7.5 -51t-18 -39 t-21 -26.5t-18.5 -16.5l-7 -5l-39 46q5 3 13 9.5t21.5 30t13.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcommaaccent",
    unicode: "\u0157",
    horizAdvX: 351,
    d: "M335 513v-67q-12 1 -25 1q-68 0 -110 -40.5t-42 -117.5v-289h-71v509h68v-79q18 33 59 58.5t104 25.5zM107 -116q0 21 -8.5 36.5t-14.5 20.5l57 20q29 -27 29 -75q0 -27 -7.5 -51t-18 -39t-21 -26.5t-17.5 -16.5l-8 -5l-39 46q5 3 13 9.5t21.5 30t13.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 672,
    d: "M637 0h-88l-167 309h-208v-309h-73v710h292q115 0 171.5 -55.5t56.5 -144.5q0 -75 -40.5 -127t-122.5 -67zM545 510q0 60 -37.5 95t-111.5 35h-222v-261h222q74 0 111.5 34.5t37.5 96.5zM334 765l-134 70v65l134 -67l135 67v-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 351,
    d: "M335 513v-67q-12 1 -25 1q-68 0 -110 -40.5t-42 -117.5v-289h-71v509h68v-79q18 33 59 58.5t104 25.5zM202 591l-134 70v65l134 -67l135 67v-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 633,
    d: "M307 52q89 0 139.5 34.5t50.5 98.5q0 45 -23 74t-60.5 42t-82 22t-89.5 20t-82.5 29t-60.5 56.5t-23 96.5q0 82 65 141t178 59q115 0 179 -64t66 -166h-71q-2 74 -48.5 119t-124.5 45q-80 0 -125.5 -35.5t-45.5 -95.5q0 -42 23.5 -68.5t60.5 -39.5t82 -21.5t90 -21 t82 -31.5t60.5 -58.5t23.5 -97.5q0 -92 -73.5 -148t-192.5 -56q-129 0 -195 64.5t-70 164.5h72q6 -79 58 -121t137 -42zM346 940h77l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 504,
    d: "M250 -12q-103 0 -153.5 48.5t-55.5 122.5h72q4 -51 38.5 -80t98.5 -29q63 0 98.5 23.5t35.5 62.5q0 40 -32.5 59.5t-78.5 26.5t-92.5 17t-79 42t-32.5 90q0 62 51 106t138 44q96 0 142 -49t52 -112h-71q-5 44 -36 71.5t-89 27.5q-57 0 -87.5 -24t-30.5 -61 q0 -33 23.5 -52t58.5 -24.5t75.5 -14.5t75.5 -20t58.5 -43t23.5 -82q0 -62 -52.5 -106t-150.5 -44zM284 759h77l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scircumflex",
    unicode: "\u015C",
    horizAdvX: 633,
    d: "M307 52q89 0 139.5 34.5t50.5 98.5q0 45 -23 74t-60.5 42t-82 22t-89.5 20t-82.5 29t-60.5 56.5t-23 96.5q0 82 65 141t178 59q115 0 179 -64t66 -166h-71q-2 74 -48.5 119t-124.5 45q-80 0 -125.5 -35.5t-45.5 -95.5q0 -42 23.5 -68.5t60.5 -39.5t82 -21.5t90 -21 t82 -31.5t60.5 -58.5t23.5 -97.5q0 -92 -73.5 -148t-192.5 -56q-129 0 -195 64.5t-70 164.5h72q6 -79 58 -121t137 -42zM189 829l134 70l135 -70v-65l-135 68l-134 -68v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scircumflex",
    unicode: "\u015D",
    horizAdvX: 504,
    d: "M250 -12q-103 0 -153.5 48.5t-55.5 122.5h72q4 -51 38.5 -80t98.5 -29q63 0 98.5 23.5t35.5 62.5q0 40 -32.5 59.5t-78.5 26.5t-92.5 17t-79 42t-32.5 90q0 62 51 106t138 44q96 0 142 -49t52 -112h-71q-5 44 -36 71.5t-89 27.5q-57 0 -87.5 -24t-30.5 -61 q0 -33 23.5 -52t58.5 -24.5t75.5 -14.5t75.5 -20t58.5 -43t23.5 -82q0 -62 -52.5 -106t-150.5 -44zM128 664l134 70l135 -70v-65l-135 68l-134 -68v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scedilla",
    unicode: "\u015E",
    horizAdvX: 633,
    d: "M243 -212l25 40q21 -20 54 -20q24 0 39 13t15 35q0 48 -51 48q-13 0 -24.5 -5t-16.5 -9l-4 -5l-31 17l32 85q-118 6 -177.5 69.5t-63.5 158.5h72q6 -79 58 -121t137 -42q89 0 139.5 34.5t50.5 98.5q0 45 -23 74t-60.5 42t-82 22t-89.5 20t-82.5 29t-60.5 56.5t-23 96.5 q0 82 65 141t178 59q115 0 179 -64t66 -166h-71q-2 74 -48.5 119t-124.5 45q-80 0 -125.5 -35.5t-45.5 -95.5q0 -42 23.5 -68.5t60.5 -39.5t82 -21.5t90 -21t82 -31.5t60.5 -58.5t23.5 -97.5q0 -88 -67.5 -143t-178.5 -60l-16 -45q9 5 29 5q41 0 66 -25.5t25 -64.5 q0 -43 -29.5 -69.5t-76.5 -26.5q-24 0 -44 6.5t-28 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scedilla",
    unicode: "\u015F",
    horizAdvX: 504,
    d: "M188 -212l25 40q21 -20 54 -20q24 0 39 13t15 35q0 48 -51 48q-13 0 -24.5 -5t-15.5 -9l-5 -5l-31 17l32 87q-91 6 -136 53t-49 117h72q4 -51 38.5 -80t98.5 -29q63 0 98.5 23.5t35.5 62.5q0 40 -32.5 59.5t-78.5 26.5t-92.5 17t-79 42t-32.5 90q0 62 51 106t138 44 q96 0 142 -49t52 -112h-71q-5 44 -36 71.5t-89 27.5q-57 0 -87.5 -24t-30.5 -61q0 -33 23.5 -52t58.5 -24.5t75.5 -14.5t75.5 -20t58.5 -43t23.5 -82q0 -59 -47 -101.5t-135 -47.5l-17 -47q9 5 29 5q41 0 66 -25.5t25 -64.5q0 -43 -29.5 -69.5t-76.5 -26.5q-24 0 -44 6.5 t-28 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 633,
    d: "M307 52q89 0 139.5 34.5t50.5 98.5q0 45 -23 74t-60.5 42t-82 22t-89.5 20t-82.5 29t-60.5 56.5t-23 96.5q0 82 65 141t178 59q115 0 179 -64t66 -166h-71q-2 74 -48.5 119t-124.5 45q-80 0 -125.5 -35.5t-45.5 -95.5q0 -42 23.5 -68.5t60.5 -39.5t82 -21.5t90 -21 t82 -31.5t60.5 -58.5t23.5 -97.5q0 -92 -73.5 -148t-192.5 -56q-129 0 -195 64.5t-70 164.5h72q6 -79 58 -121t137 -42zM319 764l-134 70v65l134 -67l135 67v-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 504,
    d: "M250 -12q-103 0 -153.5 48.5t-55.5 122.5h72q4 -51 38.5 -80t98.5 -29q63 0 98.5 23.5t35.5 62.5q0 40 -32.5 59.5t-78.5 26.5t-92.5 17t-79 42t-32.5 90q0 62 51 106t138 44q96 0 142 -49t52 -112h-71q-5 44 -36 71.5t-89 27.5q-57 0 -87.5 -24t-30.5 -61 q0 -33 23.5 -52t58.5 -24.5t75.5 -14.5t75.5 -20t58.5 -43t23.5 -82q0 -62 -52.5 -106t-150.5 -44zM260 591l-134 70v65l134 -67l135 67v-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcommaaccent",
    unicode: "\u0162",
    horizAdvX: 545,
    d: "M536 710v-70h-227v-640h-73v640h-227v70h527zM257 -116q0 21 -8.5 36.5t-14.5 20.5l57 20q29 -27 29 -75q0 -27 -7.5 -51t-18 -39t-21 -26.5t-17.5 -16.5l-8 -5l-39 46q5 3 13 9.5t21.5 30t13.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcommaaccent",
    unicode: "\u0163",
    horizAdvX: 291,
    d: "M179 449v-449h-71v449h-97v60h97v145h71v-145h104v-60h-104zM131 -116q0 21 -8.5 36.5t-14.5 20.5l57 20q29 -27 29 -75q0 -27 -7.5 -51t-18 -39t-21 -26.5t-17.5 -16.5l-8 -5l-39 46q5 3 13 9.5t21.5 30t13.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 545,
    d: "M536 710v-70h-227v-640h-73v640h-227v70h527zM272 764l-134 70v65l134 -67l135 67v-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 291,
    d: "M179 449v-449h-71v449h-97v60h97v145h71v-145h104v-60h-104zM278 682q0 32 -23 55l56 19q29 -26 29 -73q0 -41 -18 -74.5t-36 -46.5l-17 -12l-39 44q5 3 13 9.5t21.5 29t13.5 49.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 545,
    d: "M536 710v-70h-227v-249h141v-62h-141v-329h-73v329h-141v62h141v249h-227v70h527z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 291,
    d: "M179 449v-123h87v-60h-87v-266h-71v266h-74v60h74v123h-97v60h97v145h71v-145h104v-60h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 734,
    d: "M367 -15q-129 0 -205.5 79t-76.5 229v417h73v-424q0 -108 54.5 -171t154.5 -63t154.5 63t54.5 171v424h73v-417q0 -150 -77 -229t-205 -79zM431 766q-29 0 -70 20t-62 20q-35 0 -42 -36h-55q5 44 31.5 69t69.5 25q29 0 69.5 -19.5t61.5 -19.5q35 0 42 36h55 q-5 -44 -31 -69.5t-69 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 586,
    d: "M293 -12q-103 0 -157 57.5t-54 147.5v316h71v-311q0 -70 36 -109t104 -39t104 39t36 109v311h71v-316q0 -90 -54 -147.5t-157 -57.5zM361 622q-29 0 -70 20t-62 20q-35 0 -42 -36h-55q5 44 31.5 69t69.5 25q29 0 69.5 -19.5t61.5 -19.5q35 0 42 36h55q-5 -44 -31 -69.5 t-69 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 734,
    d: "M367 -15q-129 0 -205.5 79t-76.5 229v417h73v-424q0 -108 54.5 -171t154.5 -63t154.5 63t54.5 171v424h73v-417q0 -150 -77 -229t-205 -79zM528 830v-60h-321v60h321z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 586,
    d: "M293 -12q-103 0 -157 57.5t-54 147.5v316h71v-311q0 -70 36 -109t104 -39t104 39t36 109v311h71v-316q0 -90 -54 -147.5t-157 -57.5zM456 697v-60h-321v60h321z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 734,
    d: "M367 -15q-129 0 -205.5 79t-76.5 229v417h73v-424q0 -108 54.5 -171t154.5 -63t154.5 63t54.5 171v424h73v-417q0 -150 -77 -229t-205 -79zM367 818q37 0 58.5 20t21.5 57h57q0 -61 -37 -95.5t-100 -34.5t-100.5 34.5t-37.5 95.5h58q0 -37 21.5 -57t58.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 586,
    d: "M293 -12q-103 0 -157 57.5t-54 147.5v316h71v-311q0 -70 36 -109t104 -39t104 39t36 109v311h71v-316q0 -90 -54 -147.5t-157 -57.5zM296 648q37 0 58.5 20t21.5 57h57q0 -61 -37 -95.5t-100 -34.5t-100.5 34.5t-37.5 95.5h58q0 -37 21.5 -57t58.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 734,
    d: "M367 -15q-129 0 -205.5 79t-76.5 229v417h73v-424q0 -108 54.5 -171t154.5 -63t154.5 63t54.5 171v424h73v-417q0 -150 -77 -229t-205 -79zM313 860q0 -27 16 -45t44 -18q27 0 43.5 18t16.5 45q0 26 -16.5 44.5t-43.5 18.5q-28 0 -44 -18t-16 -45zM261 860 q0 47 31.5 78.5t80.5 31.5t79.5 -31.5t30.5 -78.5t-30.5 -79t-79.5 -32t-80.5 32t-31.5 79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 586,
    d: "M293 -12q-103 0 -157 57.5t-54 147.5v316h71v-311q0 -70 36 -109t104 -39t104 39t36 109v311h71v-316q0 -90 -54 -147.5t-157 -57.5zM236 695q0 -27 16 -45t44 -18q27 0 43.5 18t16.5 45q0 26 -16.5 44.5t-43.5 18.5q-28 0 -44 -18t-16 -45zM184 695q0 47 31.5 78.5 t80.5 31.5t79.5 -31.5t30.5 -78.5t-30.5 -79t-79.5 -32t-80.5 32t-31.5 79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 734,
    d: "M367 -15q-129 0 -205.5 79t-76.5 229v417h73v-424q0 -108 54.5 -171t154.5 -63t154.5 63t54.5 171v424h73v-417q0 -150 -77 -229t-205 -79zM316 940h81l-85 -170h-61zM466 940h81l-86 -170h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 586,
    d: "M293 -12q-103 0 -157 57.5t-54 147.5v316h71v-311q0 -70 36 -109t104 -39t104 39t36 109v311h71v-316q0 -90 -54 -147.5t-157 -57.5zM245 749h81l-85 -170h-61zM395 749h81l-86 -170h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 734,
    d: "M444 -135l26 -41q-1 0 -5.5 -4.5t-11 -9t-16 -9.5t-23 -8.5t-28.5 -3.5q-47 0 -71.5 30t-24.5 73q0 54 35 95q-111 12 -175.5 90.5t-64.5 215.5v417h73v-424q0 -108 54.5 -171t154.5 -63t154.5 63t54.5 171v424h73v-417q0 -138 -65 -216t-177 -90q-59 -33 -59 -92 q0 -23 12.5 -38.5t35.5 -15.5q10 0 19.5 3.5t15 8t9.5 8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 586,
    d: "M379 -127l26 -41q-1 0 -5.5 -4.5t-11 -9t-16 -9.5t-23 -8.5t-28.5 -3.5q-47 0 -71.5 30t-24.5 73q0 51 30 90q-85 10 -129 66t-44 137v316h71v-311q0 -70 36 -109t104 -39t104 39t36 109v311h71v-316q0 -80 -43 -135t-126 -67q-52 -33 -52 -88q0 -23 12.5 -38.5 t35.5 -15.5q10 0 19.5 3.5t15 8t9.5 8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 1032,
    d: "M515 613l-191 -613h-80l-228 710h82l185 -613h2l190 613h83l190 -614h2l186 614h79l-228 -711h-81l-189 614h-2zM382 830l134 70l135 -70v-65l-135 68l-134 -68v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 824,
    d: "M549 0l-137 419h-1l-139 -419h-74l-176 509h76l137 -425l140 425h74l138 -425l139 425h75l-178 -509h-74zM277 664l134 70l135 -70v-65l-135 68l-134 -68v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 615,
    d: "M530 710h85l-271 -458v-252h-73v252l-271 458h82l225 -381h2zM173 829l134 70l135 -70v-65l-135 68l-134 -68v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 532,
    d: "M142 -208l87 208l-213 509h77l173 -427l175 427h75l-302 -717h-72zM132 664l134 70l135 -70v-65l-135 68l-134 -68v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 615,
    d: "M530 710h85l-271 -458v-252h-73v252l-271 458h82l225 -381h2zM232 762q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5t34.5 -13.5t13.5 -34.5q0 -20 -13.5 -33.5t-34.5 -13.5zM380 762q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5q20 0 34 -13.5 t14 -34.5q0 -20 -14 -33.5t-34 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 659,
    d: "M602 710v-63l-455 -578h459v-69h-554v63l456 578h-452v69h546zM353 939h77l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 526,
    d: "M472 452l-330 -389h334v-63h-426v57l330 389h-326v63h418v-57zM284 759h77l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 659,
    d: "M602 710v-63l-455 -578h459v-69h-554v63l456 578h-452v69h546zM329 775q-22 0 -36.5 14t-14.5 36q0 23 14 37t37 14q22 0 36.5 -14.5t14.5 -36.5t-14.5 -36t-36.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 526,
    d: "M472 452l-330 -389h334v-63h-426v57l330 389h-326v63h418v-57zM263 627q-22 0 -36.5 14t-14.5 36q0 23 14 37t37 14q22 0 36.5 -14.5t14.5 -36.5t-14.5 -36t-36.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 659,
    d: "M602 710v-63l-455 -578h459v-69h-554v63l456 578h-452v69h546zM332 766l-134 70v65l134 -67l135 67v-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 526,
    d: "M472 452l-330 -389h334v-63h-426v57l330 389h-326v63h418v-57zM259 591l-134 70v65l134 -67l135 67v-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    d: "M336 366l-72 -372q-32 -164 -167 -164q-26 0 -49.5 8t-33.5 16l-10 8l30 55q24 -24 64 -24t62 25t34 85l71 363h-108l12 64h108l31 156q32 164 166 164q26 0 49.5 -8t33.5 -16l10 -8l-30 -55q-24 24 -64 24q-39 0 -61.5 -25.5t-33.5 -84.5l-29 -147h110l-12 -64h-111z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aringacute",
    unicode: "\u01FA",
    horizAdvX: 673,
    d: "M226 860q0 39 22.5 68.5t59.5 37.5l53 138h73l-64 -138q36 -10 57 -39t21 -67q0 -47 -30.5 -79t-79.5 -32t-80.5 32t-31.5 79zM278 860q0 -27 16 -45t44 -18q27 0 43.5 18t16.5 45q0 26 -16.5 44.5t-43.5 18.5q-28 0 -44 -18t-16 -45zM82 0h-78l292 710h79l293 -710h-81 l-67 166h-370zM336 621h-2l-158 -387h317z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aringacute",
    unicode: "\u01FB",
    horizAdvX: 638,
    d: "M202 695q0 39 22 68t58 38l54 138h72l-64 -138q37 -10 58.5 -39t21.5 -67q0 -47 -31 -79t-80 -32t-80 32t-31 79zM253 695q0 -27 16 -45t44 -18t44 18t16 45t-16 45t-44 18t-44 -18t-16 -45zM550 509v-509h-68v94q-57 -106 -193 -106q-112 0 -176 77.5t-64 188.5t64 189 t176 78q136 0 193 -106v94h68zM121 254q0 -86 49.5 -144t132.5 -58t131 58t48 144q0 87 -48 145t-131 58t-132.5 -58.5t-49.5 -144.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AEacute",
    unicode: "\u01FC",
    horizAdvX: 986,
    d: "M63 0h-85l429 710h522v-69h-404v-246h382v-69h-382v-257h404v-69h-477v166h-289zM446 638l-244 -404h250v404h-6zM575 940h77l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aeacute",
    unicode: "\u01FD",
    horizAdvX: 965,
    d: "M234 -12q-88 0 -135 40.5t-47 111.5q0 129 192 154l179 23v14q0 129 -145 129q-124 0 -144 -101h-69q11 74 63.5 118t152.5 44q147 0 192 -106q71 106 199 106q111 0 178 -74.5t67 -185.5l-1 -27h-423q5 -79 53.5 -130.5t126.5 -51.5q58 0 100.5 29.5t60.5 77.5h74 q-24 -76 -86 -123.5t-150 -47.5q-74 0 -129 34t-86 91q-26 -59 -85 -92t-138 -33zM240 47q86 0 134 46.5t48 108.5v59l-169 -23q-70 -9 -100.5 -33.5t-30.5 -64.5q0 -50 34 -71.5t84 -21.5zM672 457q-72 0 -120 -46.5t-57 -118.5h351q-8 75 -54 120t-120 45zM503 759h77 l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslashacute",
    unicode: "\u01FE",
    horizAdvX: 828,
    d: "M438 940h77l-77 -170h-66zM776 355q0 -158 -100.5 -264t-261.5 -106q-129 0 -220 69l-77 -92l-39 33l77 93q-103 105 -103 267q0 158 100.5 264t261.5 106q122 0 215 -67l75 90l39 -35l-74 -89q107 -105 107 -269zM699 355q0 130 -78 213l-380 -459q73 -56 173 -56 q124 0 204.5 84.5t80.5 217.5zM128 355q0 -127 75 -210l379 458q-72 53 -168 53q-124 0 -205 -84t-81 -217z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslashacute",
    unicode: "\u01FF",
    horizAdvX: 617,
    d: "M334 759h77l-77 -170h-66zM308 -12q-86 0 -151 46l-53 -63l-35 30l54 63q-74 76 -74 190q0 110 71.5 188.5t187.5 78.5q89 0 155 -50l63 75l35 -30l-63 -75q70 -76 70 -187q0 -109 -71.5 -187.5t-188.5 -78.5zM496 254q0 79 -43 133l-253 -303q48 -32 108 -32 q84 0 136 57.5t52 144.5zM121 254q0 -83 46 -137l253 304q-47 36 -112 36q-84 0 -135.5 -57.5t-51.5 -145.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scommaaccent",
    unicode: "\u0218",
    horizAdvX: 633,
    d: "M307 52q89 0 139.5 34.5t50.5 98.5q0 45 -23 74t-60.5 42t-82 22t-89.5 20t-82.5 29t-60.5 56.5t-23 96.5q0 82 65 141t178 59q115 0 179 -64t66 -166h-71q-2 74 -48.5 119t-124.5 45q-80 0 -125.5 -35.5t-45.5 -95.5q0 -42 23.5 -68.5t60.5 -39.5t82 -21.5t90 -21 t82 -31.5t60.5 -58.5t23.5 -97.5q0 -92 -73.5 -148t-192.5 -56q-129 0 -195 64.5t-70 164.5h72q6 -79 58 -121t137 -42zM298 -116q0 21 -8.5 36.5t-14.5 20.5l57 20q29 -27 29 -75q0 -27 -7.5 -51t-18 -39t-21 -26.5t-18.5 -16.5l-7 -5l-39 46q5 3 13 9.5t21.5 30t13.5 50.5 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scommaaccent",
    unicode: "\u0219",
    horizAdvX: 504,
    d: "M250 -12q-103 0 -153.5 48.5t-55.5 122.5h72q4 -51 38.5 -80t98.5 -29q63 0 98.5 23.5t35.5 62.5q0 40 -32.5 59.5t-78.5 26.5t-92.5 17t-79 42t-32.5 90q0 62 51 106t138 44q96 0 142 -49t52 -112h-71q-5 44 -36 71.5t-89 27.5q-57 0 -87.5 -24t-30.5 -61 q0 -33 23.5 -52t58.5 -24.5t75.5 -14.5t75.5 -20t58.5 -43t23.5 -82q0 -62 -52.5 -106t-150.5 -44zM244 -116q0 21 -8.5 36.5t-14.5 20.5l57 20q29 -27 29 -75q0 -27 -7.5 -51t-18 -39t-21 -26.5t-18.5 -16.5l-7 -5l-39 46q5 3 13 9.5t21.5 30t13.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 418,
    d: "M75 664l134 70l135 -70v-65l-135 68l-134 -68v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 418,
    d: "M209 591l-134 70v65l134 -67l135 67v-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 374,
    d: "M187 648q37 0 58.5 20t21.5 57h57q0 -61 -37 -95.5t-100 -34.5t-100.5 34.5t-37.5 95.5h58q0 -37 21.5 -57t58.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 246,
    d: "M123 627q-22 0 -36.5 14t-14.5 36q0 23 14 37t37 14q22 0 36.5 -14.5t14.5 -36.5t-14.5 -36t-36.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 303,
    d: "M93 695q0 -27 16 -45t44 -18q27 0 43.5 18t16.5 45q0 26 -16.5 44.5t-43.5 18.5q-28 0 -44 -18t-16 -45zM41 695q0 47 31.5 78.5t80.5 31.5t79.5 -31.5t30.5 -78.5t-30.5 -79t-79.5 -32t-80.5 32t-31.5 79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 271,
    d: "M200 -127l26 -41q-1 0 -5.5 -4.5t-11 -9t-16 -9.5t-23 -8.5t-28.5 -3.5q-47 0 -71.5 30t-24.5 73q0 45 25.5 83t76.5 60l30 -41q-36 -16 -55 -42.5t-19 -56.5q0 -23 12.5 -38.5t35.5 -15.5q10 0 19.5 3.5t15 8t9.5 8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 421,
    d: "M275 622q-29 0 -70 20t-62 20q-35 0 -42 -36h-55q5 44 31.5 69t69.5 25q29 0 69.5 -19.5t61.5 -19.5q35 0 42 36h55q-5 -44 -31 -69.5t-69 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 412,
    d: "M123 749h81l-85 -170h-61zM273 749h81l-86 -170h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 793,
    d: "M30 356q0 158 104 263.5t265 105.5q162 0 265.5 -105.5t103.5 -263.5t-103.5 -263.5t-265.5 -105.5q-161 0 -265 105.5t-104 263.5zM92 356q0 -138 85 -226t222 -88q138 0 223 88t85 226t-85 226t-223 88q-137 0 -222 -88t-85 -226zM266 162v377h159q74 0 112 -36t38 -95 q0 -58 -38.5 -94t-111.5 -36h-97v-116h-62zM328 335h95q90 0 90 73q0 74 -90 74h-95v-147z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 1032,
    d: "M515 613l-191 -613h-80l-228 710h82l185 -613h2l190 613h83l190 -614h2l186 614h79l-228 -711h-81l-189 614h-2zM406 940h78l66 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 824,
    d: "M549 0l-137 419h-1l-139 -419h-74l-176 509h76l137 -425l140 425h74l138 -425l139 425h75l-178 -509h-74zM299 759h78l66 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 1032,
    d: "M515 613l-191 -613h-80l-228 710h82l185 -613h2l190 613h83l190 -614h2l186 614h79l-228 -711h-81l-189 614h-2zM550 940h77l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 824,
    d: "M549 0l-137 419h-1l-139 -419h-74l-176 509h76l137 -425l140 425h74l138 -425l139 425h75l-178 -509h-74zM441 759h77l-77 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 1032,
    d: "M515 613l-191 -613h-80l-228 710h82l185 -613h2l190 613h83l190 -614h2l186 614h79l-228 -711h-81l-189 614h-2zM442 767q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5t34.5 -13.5t13.5 -34.5q0 -20 -13.5 -33.5t-34.5 -13.5zM590 767q-21 0 -34.5 13.5 t-13.5 33.5q0 21 13.5 34.5t34.5 13.5q20 0 34 -13.5t14 -34.5q0 -20 -14 -33.5t-34 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 824,
    d: "M549 0l-137 419h-1l-139 -419h-74l-176 509h76l137 -425l140 425h74l138 -425l139 425h75l-178 -509h-74zM337 630q-21 0 -34.5 13.5t-13.5 33.5q0 21 13.5 34.5t34.5 13.5t34.5 -13.5t13.5 -34.5q0 -20 -13.5 -33.5t-34.5 -13.5zM485 630q-21 0 -34.5 13.5t-13.5 33.5 q0 21 13.5 34.5t34.5 13.5q20 0 34 -13.5t14 -34.5q0 -20 -14 -33.5t-34 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 615,
    d: "M530 710h85l-271 -458v-252h-73v252l-271 458h82l225 -381h2zM204 940h78l66 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 532,
    d: "M142 -208l87 208l-213 509h77l173 -427l175 427h75l-302 -717h-72zM161 759h78l66 -170h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 500,
    d: "M500 288v-67h-500v67h500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 1000,
    d: "M1000 288v-67h-1000v67h1000z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 215,
    d: "M123 511h-80l68 199h61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 215,
    d: "M91 710h81l-68 -199h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 215,
    d: "M91 94h81l-68 -198h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 368,
    d: "M277 511h-81l68 199h61zM123 511h-80l68 199h61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 368,
    d: "M91 710h81l-68 -199h-61zM245 710h80l-68 -199h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 368,
    d: "M91 95h81l-68 -199h-61zM245 95h80l-68 -199h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 525,
    d: "M298 -80h-71v524h-177v65h177v201h71v-201h178v-65h-178v-524z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 525,
    d: "M227 710h71v-201h178v-65h-178v-258h178v-65h-178v-201h-71v201h-177v65h177v258h-177v65h177v201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 517,
    d: "M111 357q0 62 43 105t104 43q62 0 105 -43.5t43 -104.5t-43 -104t-105 -43t-104.5 43t-42.5 104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 646,
    d: "M107 -8q-24 0 -39 14.5t-15 37.5t15 38t39 15q23 0 38 -15t15 -38q0 -22 -15 -37t-38 -15zM323 -8q-23 0 -38 14.5t-15 37.5t15 38t38 15t38 -15t15 -38q0 -22 -15 -37t-38 -15zM540 -8q-24 0 -39 14.5t-15 37.5t15 38t39 15q23 0 38 -15t15 -38q0 -22 -15 -37t-38 -15z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1282,
    d: "M233 0l392 710h62l-392 -710h-62zM128 490q0 -168 93 -168q92 0 92 168q0 169 -92 169q-93 0 -93 -169zM66 490q0 107 39.5 166.5t115.5 59.5q75 0 114.5 -59.5t39.5 -166.5t-39.5 -166t-114.5 -59q-76 0 -115.5 59t-39.5 166zM607 219q0 -168 93 -168q92 0 92 168 q0 169 -92 169q-93 0 -93 -169zM545 219q0 107 39.5 166.5t115.5 59.5q75 0 114.5 -59.5t39.5 -166.5t-39.5 -166t-114.5 -59q-76 0 -115.5 59t-39.5 166zM968 219q0 -168 93 -168t93 168q0 169 -93 169t-93 -169zM906 219q0 107 40 166.5t115 59.5t115 -59.5t40 -166.5 t-40 -166t-115 -59t-115 59t-40 166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 312,
    d: "M63 258l110 212h75l-110 -212l110 -211h-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 313,
    d: "M139 470l109 -212l-109 -211h-76l110 211l-110 212h76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 383,
    d: "M-36 0l392 710h63l-392 -710h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zerosuperior",
    unicode: "\u2070",
    horizAdvX: 394,
    d: "M104 653q0 -168 93 -168t93 168q0 169 -93 169t-93 -169zM42 653q0 107 39.5 166.5t115.5 59.5t115.5 -59.5t39.5 -166.5t-40 -166t-115 -59t-115 59t-40 166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "foursuperior",
    unicode: "\u2074",
    horizAdvX: 392,
    d: "M358 593v-54h-60v-102h-58v102h-205v50l201 280h62v-276h60zM240 786l-139 -193h139v193z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fivesuperior",
    unicode: "\u2075",
    horizAdvX: 392,
    d: "M53 563h62q10 -80 88 -80q40 0 63.5 25.5t23.5 70.5q0 41 -23 66t-64 25q-36 0 -56.5 -16.5t-27.5 -37.5h-58l36 253h234v-57h-184l-16 -112q22 24 78 24q65 0 104 -42t39 -103q0 -65 -42 -108t-107 -43q-64 0 -103.5 37t-46.5 98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixsuperior",
    unicode: "\u2076",
    horizAdvX: 390,
    d: "M208 869h85q-108 -88 -152 -164l3 2q4 2 9.5 5.5t13 6.5t18 5t21.5 2q66 0 106 -43t40 -106q0 -62 -42.5 -105.5t-109.5 -43.5q-70 0 -111 44t-41 111q0 141 160 286zM289 577q0 42 -25 68.5t-64 26.5q-40 0 -64.5 -26.5t-24.5 -68.5q0 -41 24.5 -67.5t64.5 -26.5 q38 0 63.5 26.5t25.5 67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sevensuperior",
    unicode: "\u2077",
    horizAdvX: 332,
    d: "M315 869v-49q-128 -162 -172 -383h-64q47 225 158 375h-150v-58h-59v115h287z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightsuperior",
    unicode: "\u2078",
    horizAdvX: 389,
    d: "M194 481q44 0 66.5 20.5t22.5 55.5q0 34 -24 54t-65 20t-65 -20t-24 -54t23 -55t66 -21zM194 686q38 0 59 19.5t21 50.5t-20.5 50t-59.5 19t-59.5 -19t-20.5 -50t21 -50.5t59 -19.5zM194 428q-72 0 -110.5 35.5t-38.5 92.5q0 71 61 105q-50 31 -50 96q0 53 36.5 87.5 t101.5 34.5t101.5 -34.5t36.5 -87.5q0 -63 -51 -96q62 -32 62 -105q0 -57 -38 -92.5t-111 -35.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ninesuperior",
    unicode: "\u2079",
    horizAdvX: 390,
    d: "M182 437h-85q109 90 152 165l-3 -2q-4 -2 -9.5 -5t-13 -6.5t-18 -5.5t-21.5 -2q-66 0 -106 43t-40 106q0 62 42.5 105.5t109.5 43.5q70 0 111 -44t41 -111q0 -142 -160 -287zM101 730q0 -42 25 -68.5t64 -26.5q40 0 64.5 26.5t24.5 68.5q0 41 -24.5 67.5t-64.5 26.5 q-38 0 -63.5 -26.5t-25.5 -67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeroinferior",
    unicode: "\u2080",
    horizAdvX: 394,
    d: "M104 56q0 -168 93 -168t93 168q0 169 -93 169t-93 -169zM42 56q0 107 40 166.5t115 59.5t115 -59.5t40 -166.5t-40 -166t-115 -59t-115 59t-40 166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneinferior",
    unicode: "\u2081",
    horizAdvX: 275,
    d: "M179 272v-432h-61v373h-91v47l106 12h46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twoinferior",
    unicode: "\u2082",
    horizAdvX: 385,
    d: "M341 -160h-292v47l170 151q28 26 41 48.5t13 54.5q0 38 -21 61t-59 23q-41 0 -62 -24.5t-21 -67.5l1 -15h-61q-1 8 -1 16q0 66 39 106.5t105 40.5q67 0 104.5 -39t37.5 -99q0 -79 -80 -147l-114 -99h200v-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeinferior",
    unicode: "\u2083",
    horizAdvX: 387,
    d: "M139 33v52h49q42 0 62.5 19t20.5 51q0 33 -20.5 52t-60.5 19q-37 0 -57.5 -21t-23.5 -56h-60q5 58 42.5 95.5t98.5 37.5q68 0 104.5 -33.5t36.5 -90.5q0 -68 -61 -96q33 -12 50.5 -39t17.5 -60q0 -59 -40 -95.5t-108 -36.5q-65 0 -103 37t-43 101h59q3 -38 26 -60t61 -22 t61.5 20t23.5 57q0 69 -88 69h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fourinferior",
    unicode: "\u2084",
    horizAdvX: 392,
    d: "M358 -4v-54h-60v-102h-58v102h-205v50l201 280h62v-276h60zM240 189l-139 -193h139v193z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveinferior",
    unicode: "\u2085",
    horizAdvX: 392,
    d: "M53 -28h62q10 -80 88 -80q40 0 63.5 25.5t23.5 70.5q0 41 -23 66t-64 25q-36 0 -56.5 -17t-27.5 -38h-58l36 254h234v-57h-184l-16 -112q24 24 78 24q65 0 104 -42t39 -103q0 -65 -42 -108t-107 -43q-64 0 -103.5 36.5t-46.5 98.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixinferior",
    unicode: "\u2086",
    horizAdvX: 390,
    d: "M208 278h85q-110 -91 -152 -164l3 2q4 2 9.5 5t13 6.5t18 5.5t21.5 2q66 0 106 -43.5t40 -105.5q0 -63 -42.5 -106t-109.5 -43q-70 0 -111 44t-41 111q0 141 160 286zM289 -14q0 42 -25 68t-64 26q-40 0 -64.5 -26t-24.5 -68t24.5 -68t64.5 -26q39 0 64 26t25 68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveninferior",
    unicode: "\u2087",
    horizAdvX: 332,
    d: "M315 272v-49q-128 -162 -172 -383h-64q47 225 158 375h-150v-58h-59v115h287z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightinferior",
    unicode: "\u2088",
    horizAdvX: 389,
    d: "M194 -116q44 0 66.5 20.5t22.5 55.5q0 34 -24 54t-65 20t-65 -20t-24 -54t23 -55t66 -21zM194 89q38 0 59 19.5t21 50.5t-20.5 50t-59.5 19t-59.5 -19t-20.5 -50t21 -50.5t59 -19.5zM194 -169q-72 0 -110.5 35.5t-38.5 92.5q0 71 61 105q-50 31 -50 96q0 53 36.5 87.5 t101.5 34.5t101.5 -34.5t36.5 -87.5q0 -63 -51 -96q62 -32 62 -105q0 -57 -38 -92.5t-111 -35.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nineinferior",
    unicode: "\u2089",
    horizAdvX: 390,
    d: "M182 -160h-85q107 87 152 165l-3 -2q-4 -2 -9.5 -5t-13 -6.5t-18 -5.5t-21.5 -2q-66 0 -106 43t-40 105q0 63 42.5 106.5t109.5 43.5q70 0 111 -44.5t41 -111.5q0 -141 -160 -286zM101 132q0 -42 25 -68t64 -26q40 0 64.5 26t24.5 68t-24.5 68t-64.5 26q-39 0 -64 -26 t-25 -68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    d: "M44 253v58h67q-1 12 -1 44q0 8 0.5 24t0.5 22h-67v58h74q22 125 98 195.5t200 70.5q37 0 70.5 -6.5t47.5 -13.5l15 -7v-71q-54 32 -133 32q-188 0 -223 -200h224v-58h-231q-2 -26 -2 -46q0 -30 1 -44h232v-58h-224q35 -201 223 -201q35 0 68.5 8t49.5 16l15 7v-71 q-49 -27 -133 -27q-125 0 -201 70.5t-97 197.5h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 869,
    d: "M598 529l141 181h55v-410h-60v316l-134 -171h-4l-135 171v-316h-60v410h55zM349 710v-57h-127v-353h-59v353h-127v57h313z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    d: "M549 288v-68h-516v68h516z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    d: "M46 315q2 3 5 8.5t15 19t27 24t40.5 19t55.5 8.5q44 0 107.5 -23t97.5 -23q28 0 50 12t30 24l8 12l53 -38q-1 -3 -4.5 -8.5t-15 -19.5t-26.5 -24.5t-40.5 -19t-55.5 -8.5q-43 0 -107 23t-98 23q-28 0 -50 -12t-30 -24l-8 -11zM46 142q2 3 5 8.5t15 19t27 24t40.5 19 t55.5 8.5q44 0 107.5 -23t97.5 -23q28 0 50 11.5t30 23.5l8 12l53 -37q-1 -3 -4.5 -8.5t-15 -19.5t-26.5 -24.5t-40.5 -19t-55.5 -8.5q-43 0 -107 23t-98 23q-28 0 -50 -11.5t-30 -23.5l-8 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    d: "M549 187v-69h-284l-57 -118h-77l57 118h-155v69h185l66 134h-251v69h282l58 119h77l-58 -119h157v-69h-188l-66 -134h254z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    d: "M208 0l-188 254l188 255h84l-164 -221h434v-67h-434l164 -221h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    d: "M562 254l-188 -254h-84l164 221h-434v67h434l-164 221h84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen.cap",
    horizAdvX: 396,
    d: "M352 393v-66h-308v66h308z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown.cap",
    horizAdvX: 247,
    d: "M94 546h59l12 -546h-83zM124 718q23 0 38 -15t15 -38t-15 -38t-38 -15q-24 0 -39 15t-15 38t15 38t39 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown.cap",
    horizAdvX: 522,
    d: "M484 196q0 -90 -59.5 -150.5t-158.5 -60.5q-103 0 -160 55.5t-57 142.5q0 49 20 90t48 69t56 52.5t48 52.5t20 58l-4 41h70q5 -24 5 -42q0 -41 -19.5 -75.5t-47.5 -59.5t-55.5 -50.5t-47 -59t-19.5 -72.5q0 -64 38.5 -100t104.5 -36q65 0 104.5 41t39.5 108l-3 39h74 q3 -20 3 -43zM268 718q24 0 39 -14.5t15 -37.5t-15 -38t-39 -15q-23 0 -38 15t-15 38q0 22 15 37t38 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash.cap",
    horizAdvX: 500,
    d: "M500 393v-66h-500v66h500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash.cap",
    horizAdvX: 1000,
    d: "M1000 393v-66h-1000v66h1000z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered.cap",
    horizAdvX: 216,
    d: "M108 307q-24 0 -39.5 15t-15.5 38q0 24 15.5 39.5t39.5 15.5q23 0 39 -15.5t16 -39.5q0 -23 -16 -38t-39 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft.cap",
    horizAdvX: 315,
    d: "M163 355q0 -255 116 -458h-72q-117 187 -117 458t117 458h72q-116 -204 -116 -458z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright.cap",
    horizAdvX: 315,
    d: "M152 355q0 252 -117 458h72q118 -189 118 -458t-118 -458h-72q117 205 117 458z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft.cap",
    horizAdvX: 301,
    d: "M279 -38v-65h-204v916h204v-66h-135v-785h135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright.cap",
    horizAdvX: 301,
    d: "M22 -103v65h135v785h-135v66h204v-916h-204z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft.cap",
    horizAdvX: 314,
    d: "M243 -103q-65 0 -97 36t-32 101v235q0 54 -51 54h-23v63h23q51 0 51 55v235q0 65 32.5 101t96.5 36l49 -5v-65q-20 4 -45 4q-35 0 -49.5 -17t-14.5 -52v-232q0 -68 -40 -91q40 -25 40 -92v-232q0 -35 14.5 -52t49.5 -17l45 5v-66q-18 -4 -49 -4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright.cap",
    horizAdvX: 314,
    d: "M71 -103l-49 4v66q20 -5 44 -5q35 0 50 17t15 52v232q0 68 40 92q-40 23 -40 91v232q0 35 -15 52t-50 17l-44 -4v65q18 5 49 5q64 0 96 -36t32 -101v-235q0 -55 51 -55h24v-63h-24q-51 0 -51 -54v-235q0 -65 -32 -101t-96 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at.cap",
    horizAdvX: 825,
    d: "M502 379q0 49 -21 78t-64 29q-55 0 -87 -43.5t-32 -113.5q0 -108 93 -108q50 0 80.5 48t30.5 110zM653 130h67q-48 -70 -128 -110t-174 -40q-171 0 -269 102t-98 267q0 161 104.5 270.5t273.5 109.5q157 0 251 -87.5t94 -226.5q0 -111 -58 -179t-134 -68q-36 0 -57 17.5 t-28 43.5q-41 -61 -118 -61q-66 0 -105 43t-39 117q0 88 47 150.5t127 62.5q84 0 115 -66l11 52h58l-44 -222q-3 -13 -3 -27q0 -26 12.5 -40.5t34.5 -14.5q57 0 90.5 54t33.5 133q0 124 -79 194.5t-210 70.5q-145 0 -230.5 -93t-85.5 -233q0 -148 82.5 -232t224.5 -84 q76 0 137.5 28t96.5 69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.slash",
    d: "M291 -15q-118 0 -183 99t-65 271t65 271t183 99t183 -99t65 -271t-65 -271t-183 -99zM291 657q-81 0 -127 -77t-46 -225t50 -225l204 502q-38 25 -81 25zM291 53q81 0 127 77t46 225q0 147 -51 224l-204 -501q35 -25 82 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "commaaccentcomb",
    horizAdvX: 208,
    d: "M96 -116q0 21 -8.5 36.5t-14.5 20.5l57 20q29 -27 29 -75q0 -27 -7.5 -51t-18 -39t-21 -26.5t-18.5 -16.5l-7 -5l-39 46q5 3 13 9.5t21.5 30t13.5 50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.onum",
    horizAdvX: 636,
    d: "M123 264q0 -91 53 -150.5t142 -59.5t142 59.5t53 150.5t-53 151t-142 60t-142 -60t-53 -151zM49 264q0 117 75 197t194 80t194 -80t75 -197t-75 -196.5t-194 -79.5t-194 79.5t-75 196.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.onum",
    horizAdvX: 324,
    d: "M209 0h-71v458h-108v50l124 21h55v-529z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.onum",
    horizAdvX: 513,
    d: "M132 322h-73q-2 10 -2 19q0 93 53 146.5t147 53.5q90 0 142 -48.5t52 -127.5q0 -70 -44.5 -121.5t-136.5 -112.5l-99 -66h307v-65h-423v59l168 116q85 59 119.5 97.5t34.5 91.5q0 49 -32.5 80t-88.5 31q-59 0 -92 -35t-33 -100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.onum",
    horizAdvX: 534,
    d: "M197 182v65h59q68 0 104.5 32t36.5 80q0 53 -33 83.5t-97 30.5q-59 0 -92.5 -33.5t-37.5 -83.5h-74q7 85 62 135t142 50q96 0 149.5 -49t53.5 -130q0 -46 -25 -85.5t-72 -59.5q106 -34 106 -150q0 -85 -57 -139.5t-155 -54.5q-94 0 -152 56t-65 144h74q6 -56 44 -94.5 t99 -38.5q63 0 100.5 32.5t37.5 94.5q0 56 -38.5 85.5t-106.5 29.5h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.onum",
    horizAdvX: 526,
    d: "M506 107v-66h-92v-153h-68v153h-322v63l312 424h78v-421h92zM105 107h241v324h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.onum",
    horizAdvX: 542,
    d: "M76 164l52 365h331v-65h-273l-28 -196q15 15 49 29.5t81 14.5q95 0 152 -61t57 -151q0 -95 -62 -159t-157 -64q-92 0 -151 52.5t-67 136.5h73q9 -53 45.5 -88t99.5 -35q64 0 104.5 42.5t40.5 114.5q0 66 -39.5 107.5t-105.5 41.5q-50 0 -86.5 -27t-48.5 -58h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.onum",
    horizAdvX: 532,
    d: "M286 640h98q-164 -134 -222 -260q47 41 118 41q95 0 153.5 -63t58.5 -155q0 -90 -62.5 -153.5t-159.5 -63.5q-100 0 -160.5 64.5t-60.5 161.5q0 218 237 428zM418 203q0 70 -41 112t-107 42q-67 0 -107 -42.5t-40 -111.5q0 -68 41 -110t106 -42q66 0 107 42t41 110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.onum",
    horizAdvX: 448,
    d: "M91 460v-94h-71v163h412v-65q-91 -121 -137.5 -257t-74.5 -318h-75q49 341 202 571h-256z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.onum",
    horizAdvX: 542,
    d: "M271 50q70 0 106.5 34t36.5 91q0 56 -38.5 88.5t-104.5 32.5q-65 0 -103.5 -32.5t-38.5 -88.5q0 -57 36 -91t106 -34zM271 359q62 0 95.5 32.5t33.5 83.5t-33 83t-96 32q-62 0 -95.5 -32.5t-33.5 -82.5q0 -51 34 -83.5t95 -32.5zM271 -14q-104 0 -160 52t-56 134 q0 51 26 93.5t76 64.5q-40 22 -62.5 62.5t-22.5 84.5q0 75 53 126t146 51q94 0 146.5 -51t52.5 -126q0 -45 -22 -85t-63 -62q49 -22 75.5 -64.5t26.5 -93.5q0 -82 -55.5 -134t-160.5 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.onum",
    horizAdvX: 532,
    d: "M246 -114h-98q163 133 222 261q-45 -41 -118 -41q-95 0 -153.5 63t-58.5 155q0 90 62.5 153.5t159.5 63.5q100 0 160.5 -64.5t60.5 -162.5q0 -218 -237 -428zM114 324q0 -71 41 -113t107 -42t106.5 43t40.5 112q0 67 -41 109.5t-106 42.5t-106.5 -42.5t-41.5 -109.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.pnum",
    d: "M291 -15q-118 0 -183 99t-65 271t65 271t183 99t183 -99t65 -271t-65 -271t-183 -99zM291 657q-81 0 -127 -77t-46 -225t46 -225t127 -77t127 77t46 225t-46 225t-127 77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.pnum",
    horizAdvX: 387,
    d: "M247 710v-710h-73v639h-119v50l135 21h57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.pnum",
    horizAdvX: 547,
    d: "M510 0h-471v62l284 261q96 88 96 180q0 71 -40.5 113t-112.5 42q-75 0 -112.5 -45t-37.5 -120l1 -20h-74q-2 11 -2 22q0 104 60 167t165 63q109 0 168 -60.5t59 -158.5q0 -68 -30.5 -124t-97.5 -115l-223 -198h368v-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.pnum",
    horizAdvX: 557,
    d: "M203 331v65h60q80 0 122.5 36t42.5 91q0 63 -39.5 99t-115.5 36q-69 0 -106 -38.5t-42 -94.5h-73q6 85 66.5 142.5t155.5 57.5q106 0 166.5 -55t60.5 -144q0 -54 -29.5 -97t-87.5 -63q65 -19 96.5 -63t31.5 -104q0 -95 -63 -154.5t-173 -59.5q-107 0 -168.5 59t-70.5 157 h74q7 -66 49 -108t116 -42t117.5 38t43.5 110q0 65 -45 98.5t-124 33.5h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.pnum",
    horizAdvX: 585,
    d: "M552 240v-66h-92v-174h-71v174h-356v64l349 472h78v-470h92zM389 608h-1l-272 -368h273v368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.pnum",
    horizAdvX: 565,
    d: "M69 303l56 407h366v-69h-309l-32 -236q58 58 148 58q105 0 166 -67t61 -165q0 -104 -67 -175t-171 -71q-102 0 -164.5 56t-72.5 150h74q10 -60 50 -99.5t113 -39.5q72 0 117.5 49.5t45.5 129.5q0 75 -44 121t-120 46q-57 0 -98 -30.5t-54 -64.5h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.pnum",
    horizAdvX: 570,
    d: "M294 -15q-110 0 -176 71t-66 178q0 236 268 476h97q-186 -151 -255 -304q57 55 143 55q104 0 168 -69t64 -168t-68.5 -169t-174.5 -70zM461 224q0 77 -47 125.5t-120 48.5q-74 0 -120.5 -48t-46.5 -126t46.5 -125.5t120.5 -47.5q73 0 120 48t47 125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.pnum",
    horizAdvX: 502,
    d: "M480 710v-65q-190 -240 -245 -645h-79q64 409 237 641h-296v-94h-71v163h454z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.pnum",
    horizAdvX: 565,
    d: "M283 -15q-115 0 -177 57.5t-62 147.5q0 57 31 105.5t87 71.5q-48 23 -73 68t-25 97q0 82 58 137.5t161 55.5t161.5 -55.5t58.5 -138.5q0 -51 -26 -96t-74 -68q56 -23 87 -71.5t31 -105.5q0 -91 -61.5 -148t-176.5 -57zM283 332q-75 0 -119.5 -37.5t-44.5 -101.5 t42 -103.5t122 -39.5t122 39.5t42 103.5t-44.5 101.5t-119.5 37.5zM283 397q70 0 109.5 37t39.5 96q0 57 -38.5 93.5t-110.5 36.5t-110.5 -36t-38.5 -93q0 -60 39 -97t110 -37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.pnum",
    horizAdvX: 570,
    d: "M276 725q110 0 176 -71.5t66 -177.5q0 -237 -269 -476h-96q181 146 254 303q-60 -55 -143 -55q-103 0 -167 69.5t-64 168.5t68.5 169t174.5 70zM109 486q0 -78 46.5 -126.5t120.5 -48.5q73 0 120 48.5t47 126.5q0 77 -47 125t-120 48q-74 0 -120.5 -48t-46.5 -125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.dnom",
    horizAdvX: 394,
    d: "M104 216q0 -169 93 -169t93 169q0 168 -93 168t-93 -168zM42 216q0 107 40 166t115 59t115 -59t40 -166t-39.5 -166.5t-115.5 -59.5t-115.5 59.5t-39.5 166.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.dnom",
    horizAdvX: 275,
    d: "M179 431v-431h-61v373h-91v46l106 12h46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.dnom",
    horizAdvX: 385,
    d: "M341 0h-292v47l170 151q54 48 54 102q0 38 -21 61t-59 23q-41 0 -62 -24.5t-21 -66.5l1 -16h-61q-1 8 -1 17q0 66 39 106.5t105 40.5q67 0 104.5 -39t37.5 -99q0 -79 -80 -147l-114 -99h200v-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.dnom",
    horizAdvX: 387,
    d: "M139 193v51h49q42 0 62.5 19.5t20.5 51.5q0 33 -20.5 51.5t-60.5 18.5q-37 0 -57.5 -21t-23.5 -55h-60q5 58 42.5 95t98.5 37q68 0 104.5 -33.5t36.5 -89.5q0 -70 -61 -96q33 -12 50.5 -39.5t17.5 -60.5q0 -59 -40 -95.5t-108 -36.5q-65 0 -103 37.5t-43 100.5h59 q3 -38 26 -60t61 -22t61.5 20t23.5 58q0 69 -88 69h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.dnom",
    horizAdvX: 392,
    d: "M358 156v-55h-60v-101h-58v101h-205v50l201 280h62v-275h60zM240 349l-139 -193h139v193z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.dnom",
    horizAdvX: 356,
    d: "M53 124h62q10 -80 88 -80q40 0 63.5 25.5t23.5 70.5q0 41 -23 66t-64 25q-36 0 -56.5 -17t-27.5 -38h-58l36 254h234v-57h-184l-16 -112q24 24 78 24q65 0 104 -42t39 -103q0 -65 -42 -108t-107 -43q-64 0 -103.5 36.5t-46.5 98.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.dnom",
    horizAdvX: 390,
    d: "M208 430h85q-110 -91 -152 -164l3 2q4 2 9.5 5t13 6.5t18 5.5t21.5 2q66 0 106 -43.5t40 -105.5q0 -63 -42.5 -106t-109.5 -43q-70 0 -111 44t-41 111q0 141 160 286zM289 138q0 42 -25 68t-64 26q-40 0 -64.5 -26t-24.5 -68t24.5 -68t64.5 -26q39 0 64 26t25 68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.dnom",
    horizAdvX: 332,
    d: "M315 431v-49q-68 -86 -108.5 -176t-63.5 -206h-64q47 224 158 374h-150v-58h-59v115h287z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.dnom",
    horizAdvX: 389,
    d: "M194 44q44 0 66.5 20.5t22.5 55.5q0 34 -24 54t-65 20t-65 -20t-24 -54t23 -55t66 -21zM194 248q38 0 59 19.5t21 51.5q0 31 -21 50t-59 19t-59 -19t-21 -50q0 -32 21 -51.5t59 -19.5zM194 -10q-72 0 -110.5 35.5t-38.5 92.5q0 71 61 105q-50 33 -50 96q0 53 36.5 87.5 t101.5 34.5t101.5 -34.5t36.5 -87.5q0 -61 -51 -96q62 -32 62 -105q0 -57 -38 -92.5t-111 -35.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.dnom",
    horizAdvX: 390,
    d: "M182 0h-85q107 87 152 165l-3 -2q-3 -2 -6.5 -4t-9.5 -5t-12.5 -5.5t-15.5 -4t-18 -1.5q-66 0 -106 43.5t-40 105.5q0 63 42.5 106t109.5 43q70 0 111 -44t41 -111q0 -143 -160 -286zM101 292q0 -42 25 -68t64 -26q40 0 64.5 26t24.5 68t-24.5 68t-64.5 26q-39 0 -64 -26 t-25 -68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.numerator",
    horizAdvX: 394,
    d: "M104 494q0 -168 93 -168t93 168q0 169 -93 169t-93 -169zM42 494q0 107 40 166.5t115 59.5t115 -59.5t40 -166.5t-40 -166t-115 -59t-115 59t-40 166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.numerator",
    horizAdvX: 275,
    d: "M179 710v-432h-61v373h-91v47l106 12h46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.numerator",
    horizAdvX: 385,
    d: "M341 278h-292v48l170 151q28 25 41 47.5t13 54.5q0 38 -21 61t-59 23q-41 0 -62 -24.5t-21 -66.5l1 -16h-61q-1 8 -1 17q0 66 39 106t105 40q67 0 104.5 -38.5t37.5 -99.5q0 -78 -80 -147l-114 -99h200v-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.numerator",
    horizAdvX: 387,
    d: "M139 471v52h49q42 0 62.5 19t20.5 51q0 33 -20.5 52t-60.5 19q-37 0 -57.5 -21t-23.5 -56h-60q5 58 42.5 95.5t98.5 37.5q68 0 104.5 -33.5t36.5 -90.5q0 -68 -61 -96q33 -12 50.5 -39t17.5 -60q0 -59 -40 -95.5t-108 -36.5q-65 0 -103 37t-43 101h59q3 -38 26 -60 t61 -22t61.5 20t23.5 57q0 69 -88 69h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.numerator",
    horizAdvX: 392,
    d: "M358 434v-54h-60v-102h-58v102h-205v50l201 280h62v-276h60zM240 627l-139 -193h139v193z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.numerator",
    horizAdvX: 392,
    d: "M53 404h62q10 -80 88 -80q40 0 63.5 25.5t23.5 70.5q0 41 -23 66t-64 25q-36 0 -56.5 -16.5t-27.5 -37.5h-58l36 253h234v-57h-184l-16 -112q22 24 78 24q65 0 104 -42t39 -103q0 -65 -42 -108t-107 -43q-64 0 -103.5 37t-46.5 98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.numerator",
    horizAdvX: 390,
    d: "M208 710h85q-108 -88 -152 -164l3 2q4 2 9.5 5t13 6.5t18 5.5t21.5 2q66 0 106 -43t40 -106q0 -62 -42.5 -105.5t-109.5 -43.5q-70 0 -111 44t-41 111q0 141 160 286zM289 418q0 42 -25 68.5t-64 26.5q-40 0 -64.5 -26.5t-24.5 -68.5q0 -41 24.5 -67.5t64.5 -26.5 q38 0 63.5 26.5t25.5 67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.numerator",
    horizAdvX: 332,
    d: "M315 710v-49q-128 -162 -172 -383h-64q47 225 158 375h-150v-58h-59v115h287z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.numerator",
    horizAdvX: 389,
    d: "M194 322q44 0 66.5 20.5t22.5 55.5q0 34 -24 54t-65 20t-65 -20t-24 -54t23 -55t66 -21zM194 527q38 0 59 19.5t21 50.5t-20.5 50t-59.5 19t-59.5 -19t-20.5 -50t21 -50.5t59 -19.5zM194 269q-72 0 -110.5 35.5t-38.5 92.5q0 71 61 105q-50 31 -50 96q0 53 36.5 87.5 t101.5 34.5t101.5 -34.5t36.5 -87.5q0 -63 -51 -96q62 -32 62 -105q0 -57 -38 -92.5t-111 -35.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.numerator",
    horizAdvX: 390,
    d: "M182 278h-85q109 90 152 165l-3 -2q-4 -2 -9.5 -5.5t-13 -6.5t-18 -5t-21.5 -2q-66 0 -106 43t-40 106q0 62 42.5 105.5t109.5 43.5q70 0 111 -44t41 -111q0 -142 -160 -287zM101 571q0 -42 25 -68.5t64 -26.5q40 0 64.5 26.5t24.5 68.5q0 41 -24.5 67.5t-64.5 26.5 q-38 0 -63.5 -26.5t-25.5 -67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro.oldstyle",
    horizAdvX: 565,
    d: "M54 216v59h71q-2 15 -2 44q0 16 2 46h-71v59h79q23 104 90 167t176 63q37 0 69 -7t46 -13l13 -7v-72q-50 32 -128 32q-154 0 -190 -163h217v-59h-226q-2 -15 -2 -46q0 -30 2 -44h226v-59h-217q36 -164 190 -164q34 0 66 8t47 16l15 7v-71q-44 -27 -128 -27 q-110 0 -176.5 63t-89.5 168h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar.oldstyle",
    horizAdvX: 588,
    d: "M279 -124v112q-110 5 -166 62t-61 140h73q5 -58 44 -95.5t110 -42.5v243l-19 5q-97 22 -137.5 65.5t-40.5 112.5q0 71 50.5 120t146.5 53v108h49v-108q97 -9 144 -63.5t54 -128.5h-71q-21 108 -127 124v-227l14 -3q104 -24 145 -70t41 -120q0 -68 -50.5 -117.5 t-149.5 -56.5v-113h-49zM155 480q0 -45 28 -70t96 -42v218q-124 -7 -124 -106zM455 163q0 45 -29 74t-98 45v-228q64 6 95.5 35t31.5 74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent.oldstyle",
    horizAdvX: 581,
    d: "M272 -19v95q-95 9 -151.5 79.5t-56.5 164.5t56.5 164.5t151.5 79.5v96h48v-96q80 -8 131 -58.5t65 -122.5h-70q-13 48 -46 79t-80 37v-358q47 6 80 36.5t46 79.5h70q-14 -72 -65 -123t-131 -58v-95h-48zM134 320q0 -73 38 -122.5t100 -57.5v360q-62 -9 -100 -58.5 t-38 -121.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling.oldstyle",
    horizAdvX: 565,
    d: "M72 252v59h76q-42 88 -42 151q0 84 53.5 138t151.5 54q97 0 152 -56t55 -151l-2 -24h-71q2 10 2 22q0 65 -34 104t-102 39q-67 0 -100.5 -36t-33.5 -95q0 -55 48 -146h175v-59h-154q7 -24 7 -51q0 -67 -37 -111q33 -2 87.5 -21.5t91.5 -19.5q20 0 38.5 6.5t30 15.5 t20.5 17.5t13 15.5l4 6l46 -39q-2 -4 -6 -9.5t-18.5 -20.5t-31.5 -26.5t-46.5 -21t-61.5 -9.5q-44 0 -103.5 21.5t-93.5 21.5q-23 0 -46 -10.5t-34 -21.5l-11 -11l-38 46q25 32 72 49q58 44 58 117q0 28 -11 56h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin.oldstyle",
    horizAdvX: 449,
    d: "M257 324l-65 -330q-33 -164 -167 -164q-55 0 -87 26l30 56q22 -19 59 -19q39 0 61 25t34 85l63 321h-107l11 64h108l21 101q33 164 166 164q58 0 87 -26l-29 -56q-25 19 -59 19q-40 0 -62 -25t-33 -85l-18 -92h109l-11 -64h-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen.oldstyle",
    horizAdvX: 512,
    d: "M20 654h79l155 -276h2l154 276h82l-192 -328h124v-58h-132v-75h132v-56h-132v-137h-73v137h-132v56h132v75h-132v58h122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.onumtab",
    horizAdvX: 552,
    d: "M120 264q0 -96 42 -153.5t114 -57.5t114 57.5t42 153.5t-42 153.5t-114 57.5t-114 -57.5t-42 -153.5zM46 264q0 118 62 197.5t168 79.5t168 -79.5t62 -197.5t-62 -197.5t-168 -79.5t-168 79.5t-62 197.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.onumtab",
    horizAdvX: 552,
    d: "M500 64v-64h-423v64h175v394h-159v50l175 21h57v-465h175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.onumtab",
    horizAdvX: 552,
    d: "M148 322h-73q-2 10 -2 19q0 93 53 146.5t147 53.5q90 0 142 -48.5t52 -127.5q0 -70 -44.5 -121.5t-136.5 -112.5l-99 -66h307v-65h-423v59l168 116q85 59 119.5 97.5t34.5 91.5q0 49 -32.5 80t-88.5 31q-59 0 -92 -35t-33 -100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.onumtab",
    horizAdvX: 552,
    d: "M205 182v65h60q68 0 104 32t36 80q0 53 -33 83.5t-97 30.5q-59 0 -92.5 -33.5t-36.5 -83.5h-74q6 85 61.5 135t142.5 50q96 0 149.5 -49t53.5 -130q0 -46 -25 -85.5t-72 -59.5q106 -35 106 -150q0 -85 -57 -139.5t-156 -54.5q-94 0 -151.5 56t-64.5 144h73 q6 -56 44 -94.5t99 -38.5q64 0 101.5 32.5t37.5 94.5q0 56 -39 85.5t-106 29.5h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.onumtab",
    horizAdvX: 552,
    d: "M531 107v-66h-112v-153h-68v153h-322v63l312 424h78v-421h112zM110 107h241v324h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.onumtab",
    horizAdvX: 552,
    d: "M75 164l52 365h331v-65h-273l-28 -196q47 44 131 44q95 0 151.5 -61.5t56.5 -150.5q0 -95 -62 -159t-157 -64q-91 0 -150 52.5t-68 136.5h73q9 -53 45.5 -88t99.5 -35q64 0 104.5 42.5t40.5 114.5q0 66 -39.5 107.5t-105.5 41.5q-50 0 -86.5 -27t-48.5 -58h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.onumtab",
    horizAdvX: 552,
    d: "M290 640h99q-164 -132 -223 -260q47 41 119 41q94 0 152.5 -63t58.5 -155q0 -90 -62.5 -153.5t-159.5 -63.5q-100 0 -160 64.5t-60 161.5q0 217 236 428zM422 203q0 70 -41 112t-107 42q-67 0 -107 -42.5t-40 -111.5q0 -68 41 -110t106 -42q66 0 107 42t41 110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.onumtab",
    horizAdvX: 552,
    d: "M37 529h479v-65q-106 -126 -161 -259.5t-82 -315.5h-75q29 182 83 316t148 255h-321v-94h-71v163z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.onumtab",
    horizAdvX: 538,
    d: "M269 50q70 0 106.5 34t36.5 91q0 56 -38.5 88.5t-104.5 32.5q-65 0 -104 -33t-39 -88q0 -57 36 -91t107 -34zM269 359q61 0 95 32.5t34 83.5t-33 83t-96 32q-62 0 -95.5 -32.5t-33.5 -82.5q0 -51 34 -83.5t95 -32.5zM269 -14q-105 0 -160.5 52t-55.5 134q0 51 26 93.5 t76 64.5q-40 22 -62.5 62.5t-22.5 84.5q0 75 52.5 126t146.5 51t146.5 -51t52.5 -126q0 -45 -22 -85t-63 -62q49 -22 75.5 -64.5t26.5 -93.5q0 -82 -55.5 -134t-160.5 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.onumtab",
    horizAdvX: 552,
    d: "M258 -114h-98q163 133 222 261q-45 -41 -118 -41q-95 0 -153.5 63t-58.5 155q0 90 62.5 153.5t159.5 63.5q100 0 160.5 -64.5t60.5 -162.5q0 -218 -237 -428zM126 324q0 -71 41 -113t107 -42t106.5 43t40.5 112q0 67 -41 109.5t-106 42.5t-106.5 -42.5t-41.5 -109.5z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u1EF2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u1E84",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u1E82",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u1E80",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u01FA",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0178",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0176",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0174",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0134",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0104",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0102",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0100",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\xDD",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\xC5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\xC4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\xC3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\xC2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\xC1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\xC0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "Y",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "W",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "J",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "A",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EF2",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E84",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E82",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E80",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0178",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0176",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0174",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0166",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0164",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0162",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xDD",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "Y",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "W",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "T",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u01FA",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0104",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0102",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0100",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC5",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC4",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC3",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC2",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC1",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC0",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "A",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "V",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "V",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "?",
    u2: "\u2026",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "?",
    u2: "\u201E",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "?",
    u2: "\u201A",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "?",
    u2: ".",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "?",
    u2: ",",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2122",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xAE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "*",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0134",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2026",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u201E",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u201A",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EF3",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E85",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E83",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E81",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0219",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0218",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01FF",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01FE",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01FD",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01FC",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01FB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01FA",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0177",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0175",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0173",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0171",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u016F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u016D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u016B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0169",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0161",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0160",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u015F",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u015E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u015D",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u015C",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u015A",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0159",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0157",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0155",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0153",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0152",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0151",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0150",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014C",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0134",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0123",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0122",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0121",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0120",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011C",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0119",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0117",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0115",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0113",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0111",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010C",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010B",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010A",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0109",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0108",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0107",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0106",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0105",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0104",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0103",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0102",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0101",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0100",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFF",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFD",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFC",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFA",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEA",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE7",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD6",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD4",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD3",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC7",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC6",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC5",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC4",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC3",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC2",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC1",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC0",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xB5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "y",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "w",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "u",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "s",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "r",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "q",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "p",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "o",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "n",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "m",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "g",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "e",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "d",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "c",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "a",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "S",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "Q",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "O",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "J",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "G",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "C",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "G",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    g2: "periodcentered.cap",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xB7",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "V",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2026",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u201E",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u201A",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0219",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01FF",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01FD",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01FC",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01FB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01FA",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0173",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0171",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u016F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u016D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u016B",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0169",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0161",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u015F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u015D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0159",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0157",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0155",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0153",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0151",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u014F",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u014D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0134",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0131",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u012F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u012D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u012B",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0129",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0123",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0121",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u011F",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u011D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0119",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0117",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0115",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0113",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0111",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u010F",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u010D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u010B",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0109",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0107",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0105",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0104",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0103",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0102",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0101",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0100",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xFC",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xFB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xFA",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEF",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEE",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xED",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEC",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEB",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEA",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE9",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE8",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE1",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC6",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC5",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC4",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC3",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC2",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC1",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC0",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xB5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "u",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "s",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "r",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "o",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "n",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "m",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "i",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "g",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "e",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "d",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "c",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "a",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "J",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "x",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "p",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "emdash.cap",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "endash.cap",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2026",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201E",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201A",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2014",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2013",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EF3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0219",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0218",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01FF",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01FE",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01FD",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01FC",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01FB",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01FA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0177",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0173",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0171",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016F",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016D",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016B",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0169",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0161",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0160",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015F",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015D",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015A",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0159",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0157",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0155",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0153",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0152",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0151",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0150",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014F",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014E",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014D",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014C",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0134",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0123",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0122",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0121",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0120",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011F",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011E",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011D",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011C",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0119",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0117",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0115",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0113",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0111",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010F",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010D",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010C",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010B",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010A",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0109",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0108",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0107",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0106",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0105",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0104",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0103",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0102",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0101",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0100",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFF",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFD",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFC",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFB",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFA",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF9",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF8",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF6",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF5",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF4",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF2",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF0",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEB",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEA",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE9",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE8",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE7",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE6",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE5",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE4",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE2",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE0",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC7",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC6",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xB5",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "y",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "u",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "s",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "r",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "q",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "p",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "o",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "n",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "m",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "g",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "e",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "d",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "c",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "a",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "S",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "Q",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "O",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "J",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "G",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "C",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ".",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "-",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ",",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "emdash.cap",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "endash.cap",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2014",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2013",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u1EF3",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u1E85",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u1E83",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u1E81",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u01FF",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u01FE",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u01FD",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u01FB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0177",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0175",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0173",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0171",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u016F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u016D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u016B",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0169",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0153",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0152",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0151",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0150",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u014F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u014E",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u014D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u014C",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0123",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0122",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0121",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0120",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u011F",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u011E",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u011D",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u011C",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0119",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0117",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0115",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0113",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0111",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010C",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010B",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010A",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0109",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0108",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0107",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0106",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0105",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0103",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0101",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xFF",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xFD",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xFC",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xFB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xFA",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xEB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xEA",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE7",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD8",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD6",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD5",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD4",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD3",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD2",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xC7",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xB5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "y",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "w",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "u",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "q",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "o",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "g",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "e",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "d",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "c",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "a",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "Q",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "O",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "G",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "C",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "-",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "x",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "p",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "x",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "c",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "d",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u2026",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u201E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u201A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u01FF",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u01FD",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u01FB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0153",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0151",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u014F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u014D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0123",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0121",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u011F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u011D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0119",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0117",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0115",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0113",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0111",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u010F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u010D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u010B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0109",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0107",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0105",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0103",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0101",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xF8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xF6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xF5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xF4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xF3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xF2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xF0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEA",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xE9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xE8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xE7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xE6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xE5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xE4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xE3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xE2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xE1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xE0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "}",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "q",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "o",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "g",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "e",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "d",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "c",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "a",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "]",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "?",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ",",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "*",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ")",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\u1EF3",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\u1E85",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\u1E83",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\u1E81",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\u0177",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\u0175",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\xFF",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\xFD",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "y",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "w",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "v",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "p",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u01FF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u01FD",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u01FB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0153",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0151",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u014F",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u014D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0123",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0121",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u011F",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u011D",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0119",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0117",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0115",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0113",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0111",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u010F",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u010D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u010B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0109",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0107",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0105",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0103",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0101",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xEB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xEA",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "q",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "o",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "g",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "e",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "d",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "c",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "a",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u1EF3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u1EF2",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0178",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0177",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0176",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0166",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0164",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0162",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xFF",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xFD",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xDD",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "y",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "v",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "f",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "Y",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "V",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "T",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u2122",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xAE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "*",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u2122",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xAE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "*",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u2122",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xAE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "*",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u2122",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xAE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "*",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u2122",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xAE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "*",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u2122",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xAE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "*",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "x",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "p",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "x",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "c",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u2122",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\xAE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "*",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u2122",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\xAE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "*",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u2122",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xAE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "*",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0107",
    u2: "x",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0107",
    u2: "c",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0108",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0108",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0109",
    u2: "x",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0109",
    u2: "c",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010B",
    u2: "x",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010B",
    u2: "c",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010D",
    u2: "x",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010D",
    u2: "c",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0167",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0165",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0163",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u013E",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0131",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u012F",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u012D",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u012B",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0129",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xEF",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xEE",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xED",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xEC",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "t",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "l",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "k",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "j",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "i",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "h",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "f",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "b",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011C",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011C",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011C",
    u2: "G",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "G",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "G",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "G",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    g2: "periodcentered.cap",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\xB7",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "V",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    g2: "periodcentered.cap",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\xB7",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "V",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    g2: "periodcentered.cap",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\xB7",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "V",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u0167",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u0165",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u0163",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u013E",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u0131",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u012F",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u012D",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u012B",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u0129",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xEF",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xEE",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xED",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xEC",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "t",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "l",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "k",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "j",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "i",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "h",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "f",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "b",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    g2: "periodcentered.cap",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\xB7",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "V",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015C",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "x",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "p",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "x",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "p",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "x",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "p",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "x",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "p",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "x",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "p",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u2122",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\xAE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "*",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FD",
    u2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FF",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0218",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "x",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "p",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "V",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "V",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "V",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "nine.dnom",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "eight.dnom",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "seven.dnom",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "six.dnom",
    k: 141
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "five.dnom",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "four.dnom",
    k: 177
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "three.dnom",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "two.dnom",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "one.dnom",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "zero.dnom",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "endash.cap",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "endash.cap",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "emdash.cap",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "emdash.cap",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum",
    g2: "emdash.cap",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum",
    g2: "endash.cap",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum",
    u2: "\u2026",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum",
    u2: "\u201E",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum",
    u2: "\u201A",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum",
    u2: "\u2014",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum",
    u2: "\u2013",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum",
    u2: ".",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum",
    u2: "-",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum",
    u2: ",",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.pnum",
    g2: "emdash.cap",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.pnum",
    g2: "endash.cap",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.pnum",
    u2: "\u2026",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.pnum",
    u2: "\u201E",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.pnum",
    u2: "\u201A",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.pnum",
    u2: "\u2014",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.pnum",
    u2: "\u2013",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.pnum",
    u2: ";",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.pnum",
    u2: ":",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.pnum",
    u2: ".",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.pnum",
    u2: "-",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.pnum",
    u2: ",",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.numerator",
    u2: "\u2044",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.numerator",
    u2: "\u2044",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.numerator",
    u2: "\u2044",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three.numerator",
    u2: "\u2044",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.numerator",
    u2: "\u2044",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five.numerator",
    u2: "\u2044",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.numerator",
    u2: "\u2044",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.numerator",
    u2: "\u2044",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight.numerator",
    u2: "\u2044",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.numerator",
    u2: "\u2044",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Oslashacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T,Tcommaaccent,Tcaron,Tbar",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteright,quotedblright",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quotedbl,quotesingle",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "S,Sacute,Scircumflex,Scedilla,Scaron,Scommaaccent",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "u,mu,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteleft,quotedblleft",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Oslashacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "T,Tcommaaccent,Tcaron,Tbar",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent",
    g2: "T,Tcommaaccent,Tcaron,Tbar",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,Jcircumflex",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Oslashacute",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "J,Jcircumflex",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Oslashacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "T,Tcommaaccent,Tcaron,Tbar",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "quoteright,quotedblright",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "quotedbl,quotesingle",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "u,mu,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "quoteleft,quotedblleft",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,Oslashacute",
    g2: "T,Tcommaaccent,Tcaron,Tbar",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,Oslashacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,Oslashacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,Oslashacute",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,Oslashacute",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,Oslashacute",
    g2: "AE,AEacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron",
    g2: "T,Tcommaaccent,Tcaron,Tbar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,Scedilla,Scaron,Scommaaccent",
    g2: "S,Sacute,Scircumflex,Scedilla,Scaron,Scommaaccent",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,Scedilla,Scaron,Scommaaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,Scedilla,Scaron,Scommaaccent",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Oslashacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "u,mu,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "J,Jcircumflex",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "AE,AEacute",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "m,n,r,racute,rcommaaccent,rcaron",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "s,scircumflex,scedilla,scaron,scommaaccent",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "hyphen,endash,emdash,endash.cap,emdash.cap",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "AE,AEacute",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Oslashacute",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scircumflex,Scedilla,Scaron,Scommaaccent",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,mu,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J,Jcircumflex",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "AE,AEacute",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Oslashacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "u,mu,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "J,Jcircumflex",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "AE,AEacute",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "m,n,r,racute,rcommaaccent,rcaron",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "s,scircumflex,scedilla,scaron,scommaaccent",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "hyphen,endash,emdash,endash.cap,emdash.cap",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Oslashacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "u,mu,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,oe,aeacute",
    g2: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,oe,aeacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,oe,aeacute",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut,oslashacute",
    g2: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut,oslashacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut,oslashacute",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron",
    g2: "s,scircumflex,scedilla,scaron,scommaaccent",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,scircumflex,scedilla,scaron,scommaaccent",
    g2: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,scircumflex,scedilla,scaron,scommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,scircumflex,scedilla,scaron,scommaaccent",
    g2: "s,scircumflex,scedilla,scaron,scommaaccent",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tcaron,tbar",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tcaron,tbar",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tcaron,tbar",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tcaron,tbar",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tcaron,tbar",
    g2: "t,tcommaaccent,tcaron,tbar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "s,scircumflex,scedilla,scaron,scommaaccent",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "s,scircumflex,scedilla,scaron,scommaaccent",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J,Jcircumflex",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 197
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 197
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "T,Tcommaaccent,Tcaron,Tbar",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash,endash.cap,emdash.cap",
    g2: "T,Tcommaaccent,Tcaron,Tbar",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash,endash.cap,emdash.cap",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 66
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEina03Regular);
export default __webpack_public_path__ + "static/media/Eina03Regular.8a1063511545f1575acec144eaeee242.svg";
export { ForwardRef as ReactComponent };